import React, {useState,useEffect} from 'react'
import {defaultSettings, ISettings} from '../modules/profile/components/settings/SettingsModel'
import {defaultAccount, IAccount} from './MyAccountModel'
import Popup from './Popup';
import './style.css';
//import region from './address/region.json'
//import city from './address/city.json'
import companyLogo from './Avision_Logo.png';
import {db, storage} from './firebase';
import successlogo from './Otp/correct.png';
import failedlogo from './Otp/failed.png';
import loadingicon from './Otp/load-icon.png';

import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import liff from '@line/liff';
import connectWeb from'./configconnect/WebConnectionSetup.json';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  setDoc ,
} from "firebase/firestore";
import axios from 'axios';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import $ from 'jquery';
import { useForm, Controller  } from "react-hook-form";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import {Routes, Route, useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2'
import { initialStore } from '../stores/init_config_store';
// import warning from './Otp/warning.png';

export function EditeMember() {
  const [selectedCityDefault, setSelectedCityDefault] = useState<any[]>([]);
  const [selectedPostCodeDefault, setSelectedPostCodeDefault] = useState<any[]>([]);
  useEffect(() => {


    const getAllData = async () => {
      // await setDataAddress();
      await setfileconfig()
      await updateDataweb(data)
      await defaultdata()

      await regionstorage()
      await citystorage()
      await styleswebcon()
      await generateYearOptions()
      await generateMonthOptions();
      await generateDayOptions2();
      // await updatadata()
      // await setDefaultAddress();

      await consentdata();
      await checkconsentdata();
      await consentdataOther();


    };

    getAllData();

    // if(selectedCityDefault.length == 0){
    //   // console.log('55555');
    //   citystorage();
    // }
    // setStateCounty(ssssss)
  },[])



  // console.log(selectedCityDefault);
const usersCollectionRef = collection(db, "Member");
  const [ note, setNote ] = useState("");
  const [data, setData] = useState<IAccount>(defaultAccount);
  const [user, setUser] = useState('');
  //const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCancelmember, setIsOpenCancelmember] = useState(false);
  const [isOpenNotconnectBc, setIsOpenNotconnectBc] = useState(false);

  const [isOpenpopup, setIsOpenpopup] = useState(false);
  const [isOpenSaveBc, setIsOpenSaveBc] = useState(false);
  const [isOpenLoading, setIsOpenLoading] = useState(false);
  const [isOpenCheckconsent, setIsOpenCheckconsent] = useState(false);
  const [defaultdatacustomer, setdefaultdatacustomer] = useState(false);

                const logout = () => {
                  liff.logout();
                  window.location.reload();
                }
                 const [name, setName] = useState("");
                   const [userLineID, setUserLineID] = useState("");
                   const [pictureUrl, setPictureUrl] = useState("");

  const updateDataweb = async (fieldsToUpdate: Partial<IAccount>) => {
     const updatedData = {...data, ...fieldsToUpdate}
     await setData(updatedData)
  }
  async function defaultdata() {
    const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
      updateDataweb(cus_data)
      // const updatedData = {...data, ...fieldsToUpdate}
    //  await setData(updatedData)
    //  console.log("cus_data",cus_data);
  }
  const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));

// con
const togglePopup = () => {
  setIsOpen(!isOpen);
}
function checkcluburl(url:any)
{
    const encoded = encodeURIComponent(url);
    return  encoded;
}
  let clubcode = window.sessionStorage.getItem('Club_Code');

  const handleClick = async () => {
// console.log(data)
  }
  //update 6/12/2022
  const navigate = useNavigate();
  let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));

  const styles = {
    title_style: {
      "backgroundColor": stylesweb.title_style.background_color,
      "border": stylesweb.title_style.border,
      "border-color": stylesweb.title_style.border_color,
      "border-radius":stylesweb.title_style.border_radius,
      "color": stylesweb.title_style.font_color,
      "font-family": stylesweb.title_style.font_name,
      "font-size": stylesweb.title_style.font_size,
      "font-weight": stylesweb.title_style.font_weight,
    },
    title2_style: {
      "backgroundColor": stylesweb.title2_style.background_color,
      "border": stylesweb.title2_style.border,
      "border-color": stylesweb.title2_style.border_color,
      "border-radius":stylesweb.title2_style.border_radius,
      "color": stylesweb.title2_style.font_color,
      "font-family": stylesweb.title2_style.font_name,
      "font-size": stylesweb.title2_style.font_size,
      "font-weight": stylesweb.title2_style.font_weight,
    },
    caption_style: {
      "backgroundColor": stylesweb.caption_style.background_color,
      "border": stylesweb.caption_style.border,
      "border-color": stylesweb.caption_style.border_color,
      "border-radius":stylesweb.caption_style.border_radius,
      "color": stylesweb.caption_style.font_color,
      "font-family": stylesweb.caption_style.font_name,
      "font-size": stylesweb.caption_style.font_size,
      "font-weight": stylesweb.caption_style.font_weight,
    },
    input_data_style: {
      "backgroundColor": stylesweb.input_data_style.background_color,
      "border": stylesweb.input_data_style.border,
      "border-color": stylesweb.input_data_style.border_color,
      "border-radius":stylesweb.input_data_style.border_radius,
      "color": stylesweb.input_data_style.font_color,
      "font-family": stylesweb.input_data_style.font_name,
      "font-size": stylesweb.input_data_style.font_size,
      "font-weight": stylesweb.input_data_style.font_weight,
    },
    title_consent_style: {
      "backgroundColor": stylesweb.title_consent_style.background_color,
      "border": stylesweb.title_consent_style.border,
      "border-color": stylesweb.title_consent_style.border_color,
      "border-radius":stylesweb.title_consent_style.border_radius,
      "color": stylesweb.title_consent_style.font_color,
      "font-family": stylesweb.title_consent_style.font_name,
      "font-size": stylesweb.title_consent_style.font_size,
      "font-weight": stylesweb.title_consent_style.font_weight,
    },
    description_consent_style: {
      "backgroundColor": stylesweb.description_consent_style.background_color,
      "border": stylesweb.description_consent_style.border,
      "border-color": stylesweb.description_consent_style.border_color,
      "border-radius":stylesweb.description_consent_style.border_radius,
      "color": stylesweb.description_consent_style.font_color,
      "font-family": stylesweb.description_consent_style.font_name,
      "font-size": stylesweb.description_consent_style.font_size,
      "font-weight": stylesweb.description_consent_style.font_weight,
    },
    consent_page_style_body: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },
    consent_page_style_header: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "border-top-left-radius": stylesweb.consent_page_style.border_radius,
      "border-top-right-radius": stylesweb.consent_page_style.border_radius,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },
    consent_page_style_footer: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "border-bottom-left-radius": stylesweb.consent_page_style.border_radius,
      "border-bottom-right-radius": stylesweb.consent_page_style.border_radius,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },

    error_message_box_style: {
      "backgroundColor": stylesweb.error_message_box_style.background_color,
      "border": stylesweb.error_message_box_style.border,
      "border-color": stylesweb.error_message_box_style.border_color,
      "border-radius": stylesweb.error_message_box_style.border_radius,
      "color": stylesweb.error_message_box_style.font_color,
      "font-family": stylesweb.error_message_box_style.font_name,
      "font-size": stylesweb.error_message_box_style.font_size,
      "font-weight": stylesweb.error_message_box_style.font_weight,
    },
    cancel_button_style: {
      "backgroundColor": stylesweb.cancel_button_style.background_color,
      "border": stylesweb.cancel_button_style.border,
      "border-color": stylesweb.cancel_button_style.border_color,
      "border-radius": stylesweb.cancel_button_style.border_radius,
      "color": stylesweb.cancel_button_style.font_color,
      "font-family": stylesweb.cancel_button_style.font_name,
      "font-size": stylesweb.cancel_button_style.font_size,
      "font-weight": stylesweb.cancel_button_style.font_weight,
    },
    confirm_button_style: {
      "backgroundColor": stylesweb.confirm_button_style.background_color,
      "border": stylesweb.confirm_button_style.border,
      "border-color": stylesweb.confirm_button_style.border_color,
      "border-radius": stylesweb.confirm_button_style.border_radius,
      "color": stylesweb.confirm_button_style.font_color,
      "font-family": stylesweb.confirm_button_style.font_name,
      "font-size": stylesweb.confirm_button_style.font_size,
      "font-weight": stylesweb.confirm_button_style.font_weight,
    },
    //AVCDAMOSHI.002  1/04/2025  Add code for ... Add style
    general_button_style: {
      "backgroundColor": stylesweb.general_button_style.background_color,
      "border": stylesweb.general_button_style.border,
      "border-color": stylesweb.general_button_style.border_color,
      "border-radius": stylesweb.general_button_style.border_radius,
      "color": stylesweb.general_button_style.font_color,
      "font-family": stylesweb.general_button_style.font_name,
      "font-size": stylesweb.general_button_style.font_size,
      "font-weight": stylesweb.general_button_style.font_weight,
    },
    //C-AVCDAMOSHI.002  1/04/2025  Add code for ... Add style

  member_cancel_button_style: {
    "backgroundColor": stylesweb.member_cancel_button_style.background_color,
    "border": stylesweb.member_cancel_button_style.border,
    "border-color": stylesweb.member_cancel_button_style.border_color,
    "border-radius": stylesweb.member_cancel_button_style.border_radius,
    "color": stylesweb.member_cancel_button_style.font_color,
    "font-family": stylesweb.member_cancel_button_style.font_name,
    "font-size": stylesweb.member_cancel_button_style.font_size,
    "font-weight": stylesweb.member_cancel_button_style.font_weight,
  },
  confirm_message_box_style: {
    "backgroundColor": stylesweb.confirm_message_box_style.background_color,
    "border": stylesweb.confirm_message_box_style.border,
    "border-color": stylesweb.confirm_message_box_style.border_color,
    "border-radius": stylesweb.confirm_message_box_style.border_radius,
    "color": stylesweb.confirm_message_box_style.font_color,
    "font-family": stylesweb.confirm_message_box_style.font_name,
    "font-size": stylesweb.confirm_message_box_style.font_size,
    "font-weight": stylesweb.confirm_message_box_style.font_weight,
  },
  title_message_box_style: {
    "backgroundColor": stylesweb.title_message_box_style.background_color,
    "border": stylesweb.title_message_box_style.border,
    "border-color": stylesweb.title_message_box_style.border_color,
    "border-radius": stylesweb.title_message_box_style.border_radius,
    "color": stylesweb.title_message_box_style.font_color,
    "font-family": stylesweb.title_message_box_style.font_name,
    "font-size": stylesweb.title_message_box_style.font_size,
    "font-weight": stylesweb.title_message_box_style.font_weight,
  },
  description_confirm_message_box_style: {
    "backgroundColor": stylesweb.description_confirm_message_box_style.background_color,
    "border": stylesweb.description_confirm_message_box_style.border,
    "border-color": stylesweb.description_confirm_message_box_style.border_color,
    "border-radius": stylesweb.description_confirm_message_box_style.border_radius,
    "color": stylesweb.description_confirm_message_box_style.font_color,
    "font-family": stylesweb.description_confirm_message_box_style.font_name,
    "font-size": stylesweb.description_confirm_message_box_style.font_size,
    "font-weight": stylesweb.description_confirm_message_box_style.font_weight,
  },
  foreground_Style: {
    "backgroundColor": stylesweb.foreground_Style.background_color,
    "border": stylesweb.foreground_Style.border,
    "border-color": stylesweb.foreground_Style.border_color,
    "border-radius": stylesweb.foreground_Style.border_radius,
    "color": stylesweb.foreground_Style.font_color,
    "font-family": stylesweb.foreground_Style.font_name,
    "font-size": stylesweb.foreground_Style.font_size,
    "font-weight": stylesweb.foreground_Style.font_weight,
  },
  background_Style: {
    "backgroundColor": stylesweb.background_Style.background_color,
    "border": stylesweb.background_Style.border,
    "border-color": stylesweb.background_Style.border_color,
    "border-radius": stylesweb.background_Style.border_radius,
    "color": stylesweb.background_Style.font_color,
    "font-family": stylesweb.background_Style.font_name,
    "font-size": stylesweb.background_Style.font_size,
    "font-weight": stylesweb.background_Style.font_weight,
  },
  agree_box_consent: {
    "backgroundColor": stylesweb.agree_box_consent.background_color,
    "border": stylesweb.agree_box_consent.border,
    "border-color": stylesweb.agree_box_consent.border_color,
    "border-radius": stylesweb.agree_box_consent.border_radius,
    "color": stylesweb.agree_box_consent.font_color,
    "font-family": stylesweb.agree_box_consent.font_name,
    "font-size": stylesweb.agree_box_consent.font_size,
    "font-weight": stylesweb.agree_box_consent.font_weight,
  },
  };
  const togglePopupNotconnectBc = () => {
    setIsOpenNotconnectBc(!isOpenNotconnectBc);
  }
  function popupNotconnectBc() {
    setIsOpenNotconnectBc(!isOpenNotconnectBc);
  }
      const togglePopupCheckconsent = () => {
        setIsOpenCheckconsent(!isOpenCheckconsent);
      }
      const togglePopupLoading = () => {
        setIsOpenLoading(!isOpenLoading);
      }
      function popupLoading() {
        setIsOpenLoading(!isOpenLoading);
      }
      const togglePopupCancelmember = () => {
        setIsOpenCancelmember(!isOpenCancelmember);
      }
      const togglePopupSaveBc = () => {
        setIsOpenSaveBc(!isOpenSaveBc);
      }
      function popupSaveBc() {
        setIsOpenSaveBc(!isOpenSaveBc);
      }
      function popupCancelmember() {
        setIsOpenCancelmember(!isOpenCancelmember);
      }
      function popupCheckconsent() {
        setIsOpenCheckconsent(!isOpenCheckconsent);
      }
      async function handleClickCancelMember() {
        console.log("ggg");

        popupCancelmember()
      }
      async function confirmCancelMember() {


        popupLoading()
        console.log("ghhh");
        let customerweb = JSON.parse(""+window.sessionStorage.getItem('Customerdata'));


       //delete member bc
       var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Create_Update_Member;
       var myHeadersotpUsage = new Headers();
       myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
       myHeadersotpUsage.append("Content-Type", "application/json");

       var raw = JSON.stringify({
                     "memberAccountNo": customerweb.bc_account_no,
                     "clubCode": customerweb.club_code,//*
                     "schemeCode": customerweb.scheme,
                     //"schemeCode": "",//avnsd
                     "mobileNo":  "",//*
                     "lineUserId": "", //*
                     "firstName": "",//*
                     "lastName": "",//*
                     "dateOfBirth": "0001-01-01",
                     "sex": "",
                     "citizenID": "",
                     "emailAddress": "",
                     "address1": "",
                     "address2": "",
                     "city": "",
                     "county": "",
                     "postCode": "",
                     "consent1": "",
                     "dateConsent1": "0001-01-01",
                     "consent2":"",
                     "dateConsent2": "0001-01-01",
                     "consent3": "",
                     "dateConsent3": "0001-01-01",
                     "consent4": "",
                     "dateConsent4": "0001-01-01",
                     "consent5": "",
                     "dateConsent5": "0001-01-01",
                     "consent6": "",
                     "dateConsent6": "0001-01-01",
                     "apiStoreRegister": "",
                     "blocked": true,//*
                     "dateBlocked": "0001-01-01",
                     "apiType": "DELETE"
                     });
                     console.log("raw",raw);


               fetch(urlotpUsage, {
                 method: 'POST',
                 headers: myHeadersotpUsage,
                 body: raw,
                 redirect: 'follow'
               })
               .then(response => response.json())
               .then(data => {console.log("delete bc",data);
               const createdata = data;
               console.log("createdata",createdata);

               if (createdata.memberAccountNo) {


               const idfirebase=customerweb.club_code+"_"+customerweb.line_user_id;
                 const userDoc = doc(db, "Member", idfirebase);
                      deleteDoc(userDoc);

                     setIsOpenLoading(false);
                     const liffidweb = window.sessionStorage.getItem("liffid");
                     let liffweb= ""+liffidweb;
                     liff.init({liffId: liffweb})
                     .then(async () => {
                       liff.closeWindow();
                     })
                     .catch((err) => {
                     // Error happens during initialization
                     console.log(err.code, err.message);
                     });
                     return;
                     }
               //delete member web
          /*   const urldeletemember = connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data+"?type=delete";
               const res =  axios.post(urldeletemember,{club_code: customerweb.club_code,line_user_id:customerweb.line_user_id} ,{
                    headers: {
                "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                }
              }).then(res=>{
                console.log("resdeletemember",res);
                setIsOpenLoading(false);
                const liffidweb = window.sessionStorage.getItem("liffid");
                let liffweb= ""+liffidweb;
                liff.init({liffId: liffweb})
                .then(async () => {
                  liff.closeWindow();
                })
                .catch((err) => {
                // Error happens during initialization
                console.log(err.code, err.message);
                });
                return;

              //  navigate('/verifymobile');
              })
              .catch(error => console.log('error', error));*/
              //delete member


               })
               .catch(error => {
                  setIsOpenLoading(false);
                 popupNotconnectBc()

                 console.log('editeMember error', error)});


       //delete member bc
      }



  const [selectedOption, setSelectedOption] = useState<String>();
  const [selectedOptionCity, setSelectedOptionCity] = useState<String>();
  const [selectedOptionPoscode, setSelectedOptionPoscode] = useState<String>();
  const [selectedCity, setSelectedCity] = useState<any[]>([]);
  const [selectedPostCode, setSelectedPostCode] = useState<any[]>([]);


  const [birthyear, setbirthyear] = useState();
  const [birthmonth, setbirthmonth] = useState();
  const [birthday, setbirthday] = useState();
  const [webdefault, setwebdefault] = useState();
  const [stateCounty, setStateCounty] = useState<String>();
  const [genderMale, setgenderMale] = useState<Boolean>((cus_data.sex == 'Male') ? true : false);
  const [genderFemale, setgenderFemale] = useState<Boolean>((cus_data.sex == 'Female') ? true : false);
  const [genderNotSpecified, setgenderNotSpecified] = useState<Boolean>((cus_data.sex == 'null') ? true : false);





  const [dataconsent, setdataconsent] = useState('');
  const [show, setShow] = useState(false);
  const handleCloseConsent1 = () => setShow(false);
  const handleShowConsent1 = () => setShow(true);
  const handleCloseConsentOther = () => setShowModalConsentOther(false);
  const handleShowConsentOther = () => setShowModalConsentOther(true);
  const [checkConsent1, setCheckConsent1] = useState(false);
  const [checkConsent2, setCheckConsent2] = useState(false);
  const [checkConsent3, setCheckConsent3] = useState(false);
  const [checkConsent4, setCheckConsent4] = useState(false);
  const [checkConsent5, setCheckConsent5] = useState(false);
  const [checkConsent6, setCheckConsent6] = useState(false);

  const [checkConsentRequired2, setCheckConsentRequired2] = useState(true);
  const [checkConsentRequired3, setCheckConsentRequired3] = useState(true);
  const [checkConsentRequired4, setCheckConsentRequired4] = useState(true);
  const [checkConsentRequired5, setCheckConsentRequired5] = useState(true);
  const [checkConsentRequired6, setCheckConsentRequired6] = useState(true);

  const [checkChangeConsent1, setCheckChangeConsent1] = useState<Boolean>();
  const [checkChangeConsent2, setCheckChangeConsent2] = useState<Boolean>();
  const [checkChangeConsent3, setCheckChangeConsent3] = useState<Boolean>();
  const [checkChangeConsent4, setCheckChangeConsent4] = useState<Boolean>();
  const [checkChangeConsent5, setCheckChangeConsent5] = useState<Boolean>();
  const [checkChangeConsent6, setCheckChangeConsent6] = useState<Boolean>();

  const [totalConsentRequired, setTotalConsentRequired] = useState(0);
  const [checkClickConsentRequired, setCheckClickConsentRequired] = useState(0);
  const [showModalConsentOther, setShowModalConsentOther] = useState(false);
  const [checkConsentBtnClick1, setCheckConsentBtnClick1] = useState(false);
  const [checkBtnConfirmBeforeOtp, setCheckBtnConfirmBeforeOtp] = useState(false);

/*
  console.log("totalConsentRequired",totalConsentRequired);
  console.log("totalConsentRequired",checkClickConsentRequired);
  console.log("data",data);*/



  const [contentConsent2, setContentConsent2] = useState<any>({});
  const [contentConsent3, setContentConsent3] = useState<any>({});
  const [contentConsent4, setContentConsent4] = useState<any>({});
  const [contentConsent5, setContentConsent5] = useState<any>({});
  const [contentConsent6, setContentConsent6] = useState<any>({});

  // const [dataCountry, setDataCounrty] = {value:data.country};
  // let erefsd = null;
  const updateData = async (fieldsToUpdate: Partial<IAccount>) => {
    // console.log('5555',fieldsToUpdate);
    // setDataCountry(fieldsToUpdate.country);
    // erefsd = fieldsToUpdate.country
    // console.log('scs0c5sc5s1c5s1c',fieldsToUpdate);
    //console.log("data",fieldsToUpdate.sex);

    if(fieldsToUpdate.sex){
      const sex:any = fieldsToUpdate.sex;
      if(sex == "Male"){

        setgenderMale(true);
        setgenderFemale(false);
        setgenderNotSpecified(false);
      }else if (sex == 'Female'){

        setgenderMale(false);
        setgenderFemale(true);
        setgenderNotSpecified(false);
      }else if (sex == 'null'){

        setgenderMale(false);
        setgenderFemale(false);
        setgenderNotSpecified(true);
      }


    }


    const updatedData = {...data, ...fieldsToUpdate}
  //  console.log('qweqweqweqwe',updatedData);
    await setData(updatedData)

  }

  const [selectBirthYear, setSelectbirthyear] = useState<String>();
  const [selectBirthMonth, setSelectBirthMonth] = useState<String>();
  const [selectBirthDay, setSelectBirthDay] = useState<String>();

  const [checkSelectedCountry, setCheckSelectedCountry] = useState<Boolean>();
  // const [checkSelectedCity, setCheckSelectedCity] = useState<Boolean>();


  const updateDatabirthyear = (fieldsToUpdate:any) => {


    // const yearOfBirth = split_date_of_birth[0];
    //     const monthOfBirth = split_date_of_birth[1];
    //     const dayOfBirth = split_date_of_birth[2];
     const monthBirth = (selectBirthMonth) ? selectBirthMonth : cus_data.date_of_birth.split('-')[1];
     const dayBirth = (selectBirthDay) ? selectBirthDay : cus_data.date_of_birth.split('-')[2];

    const concatBirthDay = { date_of_birth: fieldsToUpdate.year + '-' + monthBirth + '-' + dayBirth};
    const updatedData = {...data, ...concatBirthDay}
    setData(updatedData)
    setSelectbirthyear(fieldsToUpdate.year);
  //  setSelectbirthyear("2014");


    // console.log(updatedData);
    // setbirthyear(fieldsToUpdate.year)
    // setData(fieldsToUpdate)
    // console.log(fieldsToUpdate.year);
    // console.log("data",data);
    // console.log("Selectbirthyear",selectBirthYear);
    // console.log("updatedData",updatedData);


  }

  const updateDatabirthmonth = (fieldsToUpdate:any) => {
    // console.log(fieldsToUpdate);
    // setbirthmonth(fieldsToUpdate.month)
    const yearBirth = (selectBirthYear) ? selectBirthYear : cus_data.date_of_birth.split('-')[0];
    const dayBirth = (selectBirthDay) ? selectBirthDay : cus_data.date_of_birth.split('-')[2];
    const concatBirthDay = { date_of_birth: yearBirth + '-' + fieldsToUpdate.month + '-' + dayBirth};
    const updatedData = {...data, ...concatBirthDay}
    setData(updatedData)
    setSelectBirthMonth(fieldsToUpdate.month)
    // console.log(updatedData, selectBirthYear);
  }


  const updateDatabirthday = (fieldsToUpdate:any) => {
    console.log("sss",optionsDay);
    setSelectBirthDay(undefined);
    // setbirthday(fieldsToUpdate.day)
    const yearBirth = (selectBirthYear) ? selectBirthYear : cus_data.date_of_birth.split('-')[0];
    const monthBirth = (selectBirthMonth) ? selectBirthMonth : cus_data.date_of_birth.split('-')[1];
    const concatBirthDay = { date_of_birth: yearBirth + '-' + monthBirth + '-' + fieldsToUpdate.day};
    const updatedData = {...data, ...concatBirthDay}

    setData(updatedData)

    setSelectBirthDay(fieldsToUpdate.day);
    console.log("SelectBirthDay",selectBirthDay);
  console.log("ccc",concatBirthDay);

     console.log(data);

  }

  const updateDataRegion = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
    setSelectedOption(fieldsToUpdate.country);


  }
  const updateDataCity = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
    setSelectedOptionCity(fieldsToUpdate.city);



  }


//     const [regionbc, setregionbc] = useState('');
//     function regiononbc() {
//       return(
//         <option  value="">
//           กรุงเทพมหานคร
//         </option>);


// }

  // async function updatadata() {
  //   let clubcode = window.sessionStorage.getItem('Club_Code');
  //   let linedata = window.sessionStorage.getItem('linedata');


  //   const res = await axios.get("https://asia-southeast1-avliffmemberdev.cloudfunctions.net/app/api/GetWebMemberData?read=detail&phone=0840012345&club="+clubcode, {
  //        headers: {
  //    "Authorization":"Basic YXNhdmFfbGluZWxpZmY6YXZzQGJhbmdrb2tzeW5j",
  //    }
  //    })
  //    .then(res=>{

  //     // console.log('ssadsadas',updatedCopy);
  //     updateData(res.data.member_data)
  //     // console.log('updateData', updatedCopy);
  //     // console.log('before',res.data.member_data);
  //     setSelectedOption(res.data.member_data.country);
  //     setSelectedOptionCity(res.data.member_data.city);
  //     // console.log('after',selectedOption);
  //     // console.log('after',data);
  //     // return res;


  //    })
  //    .catch(err=> console.log(err))
  // }
const objsetweb="";
  async function styleswebcon() {
    let setupwebdefault = window.sessionStorage.getItem('setupwebdefault');
    let setupwebdefaultconvert= ""+setupwebdefault;
    const objsetweb = JSON.parse(setupwebdefaultconvert);
    setwebdefault(objsetweb)
  }
  let setupwebdefault1 = window.sessionStorage.getItem('setupwebdefault');
  let setupwebdefaultconvert1= ""+setupwebdefault1;
  const objsetweb1 = JSON.parse(setupwebdefaultconvert1);
  //  console.log(webdefault[0].consent2_code);
  const [region, setregion] = useState<any[]>([]);
  const [errorsRegion, setErrorsRegion] = useState<String>();
  const [checkerrorsRegion, setCheckerrorsRegion] = useState(true);
  const [valuecheckerrorsRegion, setValuecheckerrorsRegion] = useState(true);



  async function regionstorage() {
    const storageRefregion = ref_storage(storage, 'config_file/region.json');
    await getDownloadURL(storageRefregion).then((urlregion) => {
    const resregion = axios.get(urlregion)
   .then((resregion:any)=> {

    const optionsRegion:any = []
    resregion.data.forEach((val:any, key:any) => {
      // console.log(val);
      optionsRegion.push(
        {
          label : val.name,
          value : val.name
        }

      );
    })

     setregion(optionsRegion)
     if(cus_data.country != ""){
      const checkRegion = optionsRegion.filter((region:any) => {
        return region.value === cus_data.country;
      });
      if(checkRegion.length == 0){
        setErrorsRegion('ข้อมูลจังหวัด "'+cus_data.country+'" ไม่ถูกต้อง กรุณาระบุข้อมูลใหม่');
        setCheckerrorsRegion(false);
        setValuecheckerrorsRegion(false)
      //  const country = { country: "null"};
      //  const updatedData = {...data, ...data}
      //  setData(updatedData)
        console.log("dddd",data);



      }


     }
        // if(cus_data.city != '' && cus_data.post_code != ''){
          // const uniqueIds:any[] = [];

          // const uniqueCity = city.filter(val => {
          //   // console.log(val.City);
          //   const isDuplicate = uniqueIds.includes(val.City);

          //   if (!isDuplicate) {
          //     // console.log(test2.City);
          //     uniqueIds.push(val.City);

          //     return true;
          //   }

          //   return false;
          // });

          // const optionsCity:any = []
          // uniqueCity.map(value => {
          //   // console.log(test2.County);
          //   if(cus_data.country == value.County) {
          //     optionsCity.push({
          //       label : value.City,
          //       value : value.City
          //     });
          //     // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
              // console.log(cus_data);
          //   }
          // });
          // setSelectedCityDefault(optionsCity)

          // const optionsPostCode:any = [];
          // city.map(value => {

          //   if(cus_data.city == value.City) {
          //     // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
          //     optionsPostCode.push({
          //       label : value.PostCode,
          //       value : value.PostCode
          //     });
          //   }
          // });
          // setSelectedPostCode(optionsPostCode);
        // }

     })
     .catch(err=> console.log(err))
     });


  }

  // console.log('55515156',selectedPostCodeDefault);
   const [city, setcity] = useState<any[]>([]);
   const [errorsCity, setErrorsCity] = useState<String>();
   const [errorsCitylabel, setErrorsCitylabel] = useState<String>();
   const [errorsPostCode, setErrorsPostCode] = useState<String>();
   const [errorsPostCodelabel, setErrorsPostCodelabel] = useState<String>();
   const [checkerrorsCity, setCheckerrorsCity] = useState(true);
   const [checkerrorsPostCode, setCheckerrorsPostCode] = useState(true);
   //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
   const logo = initialStore((state) => state.logo);
   //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
  //  interface Option {
  //   readonly label: string;
  //   readonly value: string;
  // }

  // const createOption = (label: string) => ({
  //   label,
  //   value: label,
  // });

   async function citystorage() {
   const storageRefcity = ref_storage(storage, 'config_file/city.json');
   await getDownloadURL(storageRefcity).then((urlcity) => {
   const rescity =  fetch(urlcity)
    .then(response => response.json())
    .then(res_data=> {
      setcity(res_data)
      // console.log(res_data);
      // const optionsRegion:any = []
      // resregion.data.forEach((val:any, key:any) => {
      //   // console.log(val);
      //   optionsRegion.push(
      //     {
      //       label : val.name,
      //       value : val.name
      //     }

      //   );
      // })
        const check_country = (data.country != '') ? data.country : cus_data.country;
        const check_city = (data.city != '') ? data.city : cus_data.city;
        console.log("check_country",check_country);

        console.log("check_city",check_city);

        if(check_country != '' && check_city != ''){
          setCheckSelectedCountry(false);
          // setTimeout(() => {

            const uniqueIds:any[] = [];
            const uniqueCity = res_data.filter((val:any) => {
              // console.log(val.City);
              const isDuplicate = uniqueIds.includes(val.City);

              if (!isDuplicate) {
                // console.log(test2.City);
                uniqueIds.push(val.City);

                return true;
              }

              return false;
            });

            const optionsCity:any = []
            const optionsPostCode:any = [];
            // const check_city = (data.country) ? data.country : cus_data.country
            // console.log(data.country);
            uniqueCity.map((value:any) => {
              // console.log(test2.County);
              if(check_country == value.County) {
                optionsCity.push({
                  label : value.City,
                  value : value.City
                });
                // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
                // console.log(test2.City);
              }


              // if(check_city == value.City) {
              //   // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
              //   optionsPostCode.push({
              //     label : value.PostCode,
              //     value : value.PostCode
              //   });
              // }
            });



            res_data.map((value:any )=> {

              if (check_city == value.City) {
                  // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
                optionsPostCode.push({
                  label : value.PostCode,
                  value : value.PostCode
                });
              }
            });

            if(optionsPostCode.length == 0){
              setErrorsCity('ข้อมูลอำเภอ/เขต "'+check_city+'" ไม่ถูกต้อง กรุณาระบุข้อมูลใหม่');
              setCheckerrorsCity(false);
            }

            if(cus_data.post_code != ''){
              const checkPostCode = res_data.filter((post_code:any) => {
                return post_code.PostCode === cus_data.post_code;
              });

              if(checkPostCode.length == 0){
                setErrorsPostCode('ข้อมูลรหัสไปรษณีย์ "'+cus_data.post_code+'" ไม่ถูกต้อง กรุณาระบุข้อมูลใหม่')
                setCheckerrorsPostCode(false);
              }

            }

            // uniqueCity.map((value:any) => {
            //   // console.log(test2.County);
            //   if(data.city == value.City) {
            //     // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
            //     optionsPostCode.push({
            //       label : value.PostCode,
            //       value : value.PostCode
            //     });
            //   }
            // });
            setSelectedCityDefault(optionsCity)



          //  setSelectedCity(optionsCity)
            setSelectedPostCodeDefault(optionsPostCode);
          // console.log(optionsPostCode);
          // console.log(selectedCityDefault);
          // }, 3000);



          // city.map((value:any) => {

          //   if(cus_data.city == value.City) {
          //     // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
          //     optionsPostCode.push({
          //       label : value.PostCode,
          //       value : value.PostCode
          //     });
          //   }
          // });



        }else{
          setCheckSelectedCountry(true);
            if(check_country != '' && check_city == ''){
              setCheckSelectedCountry(false);
              // setTimeout(() => {

                const uniqueIds:any[] = [];
                const uniqueCity = res_data.filter((val:any) => {
                  // console.log(val.City);
                  const isDuplicate = uniqueIds.includes(val.City);

                  if (!isDuplicate) {
                    // console.log(test2.City);
                    uniqueIds.push(val.City);

                    return true;
                  }

                  return false;
                });

                const optionsCity:any = []
                const optionsPostCode:any = [];
                // const check_city = (data.country) ? data.country : cus_data.country
                // console.log(data.country);
                uniqueCity.map((value:any) => {
                  // console.log(test2.County);
                  if(check_country == value.County) {
                    optionsCity.push({
                      label : value.City,
                      value : value.City
                    });
                    // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
                    // console.log(test2.City);
                  }


                  // if(check_city == value.City) {
                  //   // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
                  //   optionsPostCode.push({
                  //     label : value.PostCode,
                  //     value : value.PostCode
                  //   });
                  // }
                });



                res_data.map((value:any )=> {

                  if (check_city == value.City) {
                      // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
                    optionsPostCode.push({
                      label : value.PostCode,
                      value : value.PostCode
                    });
                  }
                });



                // uniqueCity.map((value:any) => {
                //   // console.log(test2.County);
                //   if(data.city == value.City) {
                //     // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
                //     optionsPostCode.push({
                //       label : value.PostCode,
                //       value : value.PostCode
                //     });
                //   }
                // });
                setSelectedCityDefault(optionsCity)



              //  setSelectedCity(optionsCity)
                setSelectedPostCodeDefault(optionsPostCode);
            }
        }
          console.log("ckdd",selectedCityDefault);
      // console.log('setcity', rescity.data);
      })
      .catch(err=> console.log(err))
      });


      }
      // console.log(checkSelectedCountry);
    const  [optionsYear, setOptionsYear] = useState<any[]>([]);

    const generateYearOptions = () => {
      const arr = [];

      const startYear = 1900;
      const endYear = new Date().getFullYear();

      for (let i = endYear; i >= startYear; i--) {
        // arr.push(<option value={i}>{i}</option>);
        arr.push({
          label: ('' + i),
          value: ('' + i)
        });
      }
      setOptionsYear(arr);
      // console.log(arr);
      // return arr;
    };
    // console.log(optionsYear);
    const  [optionsMonth, setOptionsMonth] = useState<any[]>([]);
    const generateMonthOptions = () => {
      const arr = [];
      //  const startMonth = 12;
        const endMonth = 12;

        for (let i = 1; i <= endMonth; i++) {
          // arr.push(<option value={('0' + i).slice(-2)}>{('0' + i).slice(-2)}</option>);
          arr.push({
            label: ('0' + i).slice(-2),
            value: ('0' + i).slice(-2)
          })
        }
        // console.log(arr);
        setOptionsMonth(arr);
        // return arr;
    };

    const  [optionsDay, setOptionsDay] = useState<any[]>([]);
    const generateDayOptions = (e:any) => {
      const arr = [];
      let month:any =  (e.type === 'month') ? e.value : null;
      if(e.type === 'year'){
        month = selectBirthMonth
      }
      let year:any = (e.type === 'year') ? e.value : null;
      if(e.type === 'month'){
        year = selectBirthYear;
      }
      // console.log('indide fn year',selectBirthYear);
      // console.log('indide fn month',month);
        if(year != null && month != null){
          console.log('inside gen');
          var res = 31;
              if (month != null) {
                if (month == '04' || month == '06' || month == '09' || month == '11') {
                  res = 30;
                }
                if (year != null && month == '02') {
                  res = year % 4 == 0 && year % 100 != 0 ? 29 : 28;
                }
              }
          const endday = res;

          for (let i = 1; i <= endday; i++) {
            // arr.push(<option value={('0' + i).slice(-2)}>{('0' + i).slice(-2)}</option>);
            arr.push({
              label: ('0' + i).slice(-2),
              value: ('0' + i).slice(-2)

            })
          }
          // console.log(arr);
          setOptionsDay(arr);
        }
        // return arr;
    };


    const generateDayOptions2 = () => {
      const arr = [];
      // console.log(cus_data.date_of_birth.split('-'));
      let month:any =  cus_data.date_of_birth.split('-')[1];
      let year:any = cus_data.date_of_birth.split('-')[0];
      let day:any = cus_data.date_of_birth.split('-')[2];
      setSelectBirthMonth(month);

      setSelectbirthyear(year);

      if (selectBirthDay== undefined) {

        if (year=="0001") {
            setSelectBirthDay("00");
            setSelectBirthMonth("00");
            setSelectbirthyear("0000");
        }else{
        setSelectBirthDay(day)
      }
        console.log("day",day);

      }
    //  setSelectBirthDay(day)
    //   console.log('indide fn year',year);
    //   console.log('indide fn day',day);
      // console.log('indide fn month',month);
        if(year != null && month != null){
          // console.log('inside gen');
          var res = 31;
              if (month != null) {
                if (month == '04' || month == '06' || month == '09' || month == '11') {
                  res = 30;
                }
                if (year != null && month == '02') {
                  res = year % 4 == 0 && year % 100 != 0 ? 29 : 28;
                }
              }
          const endday = res;

          for (let i = 1; i <= endday; i++) {
            // arr.push(<option value={('0' + i).slice(-2)}>{('0' + i).slice(-2)}</option>);
            arr.push({
              label: ('0' + i).slice(-2),
              value: ('0' + i).slice(-2)

            })
          }
          // console.log(arr);
          setOptionsDay(arr);
        }
        // return arr;
    };




    const [blogs,setBlogs]=useState([])
    const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));
    const [input, setInput] = useState("");
    function authenticateUser(user:string, password:string)
    {
        var token = user + ":" + password;
        var hash = btoa(token);
        return "Basic " + hash;
    }
    // const handleSubmit = (e:any) => {
    //   var data1 = JSON.stringify(data);
    //   var urlupdate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;

    //   const resp =  axios.post(urlupdate,data,{
    //     headers: {
    //       "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
    //     }
    //   })
    //   .then(resp=>{
    //     console.log(resp);
    //     sessionStorage.setItem("Customerdata", JSON.stringify(data));
    //   })
    //   .catch(err=> console.log(err))
    //     e.preventDefault();
    //     alert("Hello " + data.country);
    //     setInput("");
    //     return false;
    // };


        const changeProvince =( e : any) => {
          // e.preventDefault();
          // console.log(e.value);
          console.log("provin");
        /*  const clearcity= { city: "undef",post_code: "undef"};
          const updatedDatacity = {...data, ...clearcity}
          setData(updatedDatacity)
          */


          setCheckSelectedCountry(true);
        //  updateData({country: e.value});
        updateData({
                    country: e.value,
                    city: '',
                    post_code: ''
                  });
          setSelectedOption(e.value);
          setSelectedCity([]);

          const uniqueIds:any[] = [];

            const uniqueCity = city.filter(val => {
              // console.log(val.City);
              const isDuplicate = uniqueIds.includes(val.City);

              if (!isDuplicate) {
                // console.log(test2.City);
                uniqueIds.push(val.City);

                return true;
              }

              return false;
            });


            // console.log(uniqueCity);

          // const uniqueNames = Object.values(city).filter((val, id, array) => {
          //   const test = JSON.stringify(val);
          //   const test2 = JSON.parse(test);
          //   // console.log(test2.City);
          //   // return array.indexOf(test2.City) == id;
          //   console.log(id);
          // });

          // Object.values(city).forEach(val_city => {
            // console.log('uniqueNames', uniqueNames);
          // });

          // console.log(uniqueNames);
          const optionsCity:any = []
            uniqueCity.map(value => {
              // console.log(test2.County);
              if(e.value == value.County) {
                optionsCity.push({
                  label : value.City,
                  value : value.City
                });
                // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
                // console.log(test2.City);
              }
            });

            setSelectedCity(optionsCity)


         //console.log('5s5s5s5',data);






        }


        // console.log('5s5s5s5',selectedCity);

        const changeCity =( e : any) => {
          console.log("lll");

          updateDataCity({city: e.value});
          //updateData({city: e.value});
          updateData({
            country : data.country,
            city: e.value,
            post_code: ''
          });
          const optionsPostCode:any = [];
          city.map(value => {

            if(e.value == value.City) {
              // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
              optionsPostCode.push({
                label : value.PostCode,
                value : value.PostCode
              });
            }
          });
          // console.log("optionsPostCode[0]",optionsPostCode[0]);
            // updateData({post_code: optionsPostCode[0].value});
            if(checkSelectedCountry == false){
              setSelectedPostCodeDefault(optionsPostCode);
            }else if(checkSelectedCountry == true){
              setSelectedPostCode(optionsPostCode);
            }

          // console.log(data.country);

        }

        const changePostCode =( e : any) => {

          updateData({post_code: e.value});
          // console.log(e);

        }

        // const setDataAddress = () =>{
          // console.log(55555555);
          // if(cus_data.city != '' && cus_data.post_code != ''){
          //   const uniqueIds:any[] = [];

          //   const uniqueCity = city.filter(val => {
          //     // console.log(val.City);
          //     const isDuplicate = uniqueIds.includes(val.City);

          //     if (!isDuplicate) {
          //       // console.log(test2.City);
          //       uniqueIds.push(val.City);

          //       return true;
          //     }

          //     return false;
          //   });

          //   const optionsCity:any = []
          //   uniqueCity.map(value => {
          //     // console.log(test2.County);
          //     if(cus_data.country == value.County) {
          //       optionsCity.push({
          //         label : value.City,
          //         value : value.City
          //       });
          //       // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
          //       // console.log(test2.City);
          //     }
          //   });
          //   setSelectedCity(optionsCity)

          //   const optionsPostCode:any = [];
          //   city.map(value => {

          //     if(cus_data.city == value.City) {
          //       // setSelectedPostCode( selectedPostCode => [...selectedPostCode, `${value.PostCode}`]);
          //       optionsPostCode.push({
          //         label : value.PostCode,
          //         value : value.PostCode
          //       });
          //     }
          //   });
          //   setSelectedPostCode(optionsPostCode);
          // }
        // }





        // console.log('5555',region);
        // console.log(selectedOption);



        /// style web
        // let stylesweb = window.sessionStorage.getItem('stylesweb');
        // let styleswebconvert= ""+stylesweb;
        // const obj = JSON.parse(styleswebconvert);
        // console.log(obj);
        // const backgroundColor=obj.backgroundColor;
        // const fontColor=obj.color;


        // interface IFormInput {
        //   firstName: string;
        //   lastName: string;
        //   idCardNo: string;
        //   mobile_phone_number: string;
        //   email: string;
        //   sex: string;
        //   checkBirthDay: string;
        //   checkBirthMonth: string;
        //   checkBirthYear: string;
        //   checkAddress1: string;
        //   checkSelectedRegion: string;
        //   checkSelectedCity: string;
        //   checkSelectedPostCode: string;
        // }




        // const member_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
        // if(cus_data.date_of_birth == '0001-01-01'){
        // let split_date_of_birth = null
        // if(cus_data.date_of_birth == '0001-01-01'){
        //   const defult_date_of_birth = '0000-00-00';
        //   split_date_of_birth = defult_date_of_birth.split('-');
        // }else{
        //   split_date_of_birth = cus_data.date_of_birth.split('-');
        // }


                let split_date_of_birth = null
                if(cus_data.date_of_birth == '0001-01-01'){
                  const defult_date_of_birth = '0000-00-00';
                  split_date_of_birth = defult_date_of_birth.split('-');

                }else{
                  split_date_of_birth = cus_data.date_of_birth.split('-');
                }
                // console.log(cus_data);
                const yearOfBirth = split_date_of_birth[0];
                const monthOfBirth = split_date_of_birth[1];
                const dayOfBirth = split_date_of_birth[2];


        // const test_country = cus_data.country;
        // console.log(data.date_of_birth.split('-')[1]);
        // console.log(monthOfBirth);
        // console.log(dayOfBirth);

        const {
          register,
          handleSubmit,
          watch,
          control,
          resetField,
          formState: { errors }
        } = useForm({

                defaultValues: {
                  firstName: cus_data.first_name,
                  lastName: cus_data.last_name,
                  idCardNo: cus_data.id_card_no,
                  mobile_phone_number: cus_data.mobile_phone_no,
                  email: cus_data.email_address,
                  sex: cus_data.sex,
                  checkBirthDay: dayOfBirth,
                  checkBirthMonth: monthOfBirth,
                  checkBirthYear: yearOfBirth,
                  checkAddress1: cus_data.address,
                  checkAddress2: cus_data.address2,
                  // checkSelectedRegion: (selectedOption) ? selectedOption : data.country,
                  checkSelectedRegion:  cus_data.country,
                  checkSelectedCity: cus_data.city,
                  checkSelectedPostCode: cus_data.post_code,
                  checkSelectedCity2: data.city,
                  checkSelectedPostCode2: data.post_code
                }
              });

        // useForm({
        //   firstName: data.first_name,
        //   lastName: data.last_name,
        //   idCardNo: data.id_card_no,
        //   mobile_phone_number: data.mobile_phone_no,
        //   email: data.email_address,
        //   sex: data.sex,
        //   checkBirthDay: data.date_of_birth,
        //   checkBirthMonth: data.date_of_birth,
        //   checkBirthYear: data.date_of_birth,
        //   checkAddress1: data.address,
        //   checkSelectedRegion: data.country,
        //   checkSelectedCity: data.city,
        //   checkSelectedPostCode: data.post_code,
        // });

        // useForm({
        //       defaultValues: {
        //         firstName: data.first_name,
        //         lastName: data.last_name,
        //         idCardNo: data.id_card_no,
        //         mobile_phone_number: data.mobile_phone_no,
        //         email: data.email_address,
        //         sex: data.sex,
        //         checkBirthDay: data.date_of_birth,
        //         checkBirthMonth: data.date_of_birth,
        //         checkBirthYear: data.date_of_birth,
        //         checkAddress1: data.address,
        //         checkSelectedRegion: data.country,
        //         checkSelectedCity: data.city,
        //         checkSelectedPostCode: data.post_code,
        //       }
        //     });

        // const { register, setValue } = useForm({defaultValues: {name: '123'}})
        const [inputdobbc, setInputdobbc] = useState(true);
        const [inputpostcodebc, setInputpostcodebc] = useState(true);
const [loading, setLoading] = useState(false);
        const onSubmit = (val:any) => {
          console.log("popup",checkClickConsentRequired);
          console.log("popu2",totalConsentRequired);
          setInputdobbc(true);

          if (checkClickConsentRequired!=totalConsentRequired) {
            popupCheckconsent()
            return;
          }
          console.log("checkerrorsRegion",checkerrorsRegion);

          if (checkerrorsRegion==false) {
            console.log("region");

            return;
          }
          if (checkerrorsCity==false) {
            console.log("City");
            setErrorsCitylabel("กรุณาเลือกอำเภอ / เขต");
            return;
          }
          if (checkerrorsPostCode==false) {
            console.log("PostCode");
            setErrorsPostCodelabel("กรุณาเลือกรหัสไปรณีย์");
            return;
          }
          const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));

          if (setupwebdefaultweb.consent1_path && setupwebdefaultweb.consent1_require==true) {
            console.log("1");
            if (data.consent1==true) {
            }else{
              popupCheckconsent()
              return;
            }
          }
          if (setupwebdefaultweb.consent2_code && setupwebdefaultweb.consent2_require==true) {
            console.log("2");
            if (data.consent2==true) {
            }else{

                popupCheckconsent()
                return;
            }
          }
          if (setupwebdefaultweb.consent3_code && setupwebdefaultweb.consent3_require==true) {
            console.log("3");
            if (data.consent3==true) {
            }else{
              popupCheckconsent()
              return;
            }
          }
          if (setupwebdefaultweb.consent4_code && setupwebdefaultweb.consent4_require==true) {
            console.log("4");

            if (data.consent4==true) {
            }else{
              popupCheckconsent()
              return;
            }
          }
          if (setupwebdefaultweb.consent5_code && setupwebdefaultweb.consent5_require==true) {
            console.log("5");
            if (data.consent5==true) {
            }else{
              popupCheckconsent()
              return;
            }
          }
          if (setupwebdefaultweb.consent6_code && setupwebdefaultweb.consent6_require==true) {
            console.log("6");
            if (data.consent6==true) {
            }else{
              popupCheckconsent()
              return;
            }
          }


            if (selectBirthYear=='0000' && selectBirthMonth=='00' && selectBirthDay=='00') {
              console.log("date_of_birth selectBirthYear Month day");
              setInputdobbc(false);
              return;
            }else if(selectBirthYear!='0000' && selectBirthMonth=='00' && selectBirthDay=='00') {
              console.log("date_of_birth selectBirth  Month day");
              setInputdobbc(false);
              return;
            }else if(selectBirthYear!='0000' && selectBirthMonth!='00' && selectBirthDay=='00') {
              console.log("date_of_birth nonselectBirth day");
              setInputdobbc(false);
              return;
            }else if(selectBirthYear=='0000' && selectBirthMonth=='00' && selectBirthDay!='00') {
              console.log("date_of_birth nonselectBirth Year Month");
              setInputdobbc(false);
              return;
            }else if(selectBirthYear=='0000' && selectBirthMonth!='00' && selectBirthDay!='00') {
              console.log("date_of_birth nonselectBirth Year ");
              setInputdobbc(false);
              return;
            }else if(selectBirthYear=='0000' && selectBirthMonth!='00' && selectBirthDay=='00') {
              console.log("date_of_birth nonselectBirth Year Day ");
              setInputdobbc(false);
              return;
            }
            else{
              console.log("date_of_birth nonselectBirthDay");
            }
            if (data.post_code=="") {
              setInputpostcodebc(false);
              return;
            }

          popupLoading()
          // alert(JSON.stringify(val));

       var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Create_Update_Member;
       var myHeadersotpUsage = new Headers();
       myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
       myHeadersotpUsage.append("Content-Type", "application/json");
       const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
       console.log("cus_data",cus_data);
       console.log("data",data);

        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var newdate = year + "-" + month + "-" + day;

       var raw = JSON.stringify({
            "memberAccountNo": data.bc_account_no,
            "clubCode": data.club_code,
            "schemeCode": data.scheme,
            "mobileNo":  data.mobile_phone_no,
            "lineUserId": data.line_user_id,
            "firstName": data.first_name,
            "lastName": data.last_name,
            "dateOfBirth": data.date_of_birth,
          //  "dateOfBirth": "0001-01-01",
            "sex": (data.sex=="Male")?"M":(data.sex=="Female")?"F":"",
            "citizenID": data.id_card_no,
            "emailAddress": data.email_address,
            "address1": data.address,
            "address2": data.address2,
            "county": data.country,
            "city": data.city,
            "postCode": data.post_code,
          //  "county": "",
          //  "city":"",
          // "postCode": "",
            "consent1": (String(data.consent1)==="")?"":(data.consent1==true)?"Yes":"No",
            "dateConsent1": (cus_data.consent1==data.consent1)?data.consent1_date:newdate,
            "consent2":(String(data.consent2)==="")?"":(data.consent2==true)?"Yes":"No",
            "dateConsent2": (cus_data.consent2==data.consent2)?data.consent2_date:newdate,
            "consent3": (String(data.consent3)==="")?"":(data.consent3==true)?"Yes":"No",
            "dateConsent3": (cus_data.consent3==data.consent3)?data.consent3_date:newdate,
            "consent4": (String(data.consent4)==="")?"":(data.consent4==true)?"Yes":"No",
            "dateConsent4": (cus_data.consent4==data.consent4)?data.consent4_date:newdate,
            "consent5": (String(data.consent5)==="")?"":(data.consent5==true)?"Yes":"No",
            "dateConsent5": (cus_data.consent5==data.consent5)?data.consent5_date:newdate,
            "consent6": (String(data.consent6)==="")?"":(data.consent6==true)?"Yes":"No",
            "dateConsent6": (cus_data.consent6==data.consent6)?data.consent6_date:newdate,
            "apiStoreRegister": "",
            "blocked": false,
            "dateBlocked": "0001-01-01",
            "apiType": "UPDATE"
            });
                     console.log("raw",raw);

               fetch(urlotpUsage, {
                 method: 'POST',
                 headers: myHeadersotpUsage,
                 body: raw,
                 redirect: 'follow'
               })
               .then(response => response.json())
               .then(data_edit => {
                 console.log("ecdit bc",data_edit);
                  console.log(data_edit);
                  if(data_edit.errors){
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'ระบบไม่สามารถใช้งานได้ในขณะนี กรุณาทำรายการภายหลังอีกครั้ง ขออภัยในความไม่สะดวก Error Code : 001',
                    })
                  }else{
                    const datatotfirebase ={
                      "address":  data.address,
                      "address2": data.address2,
                      "bc_account_no": data.bc_account_no,
                      "club_code": data.club_code,
                      "consent1": data.consent1,
                      "consent1_date":(String(data.consent1)==="")?"0001-01-01":(cus_data.consent1==data.consent1)?data.consent1_date:newdate,
                      "consent2": data.consent2,
                      "consent2_date": (String(data.consent2)==="")?"0001-01-01":(cus_data.consent2==data.consent2)?data.consent2_date:newdate,
                      "consent3": data.consent3,
                      "consent3_date": (String(data.consent3)==="")?"0001-01-01":(cus_data.consent3==data.consent3)?data.consent3_date:newdate,
                      "consent4": data.consent4,
                      "consent4_date": (String(data.consent4)==="")?"0001-01-01":(cus_data.consent4==data.consent4)?data.consent4_date:newdate,
                      "consent5": data.consent5,
                      "consent5_date": (String(data.consent5)==="")?"0001-01-01":(cus_data.consent5==data.consent5)?data.consent5_date:newdate,
                      "consent6": data.consent6,
                      "consent6_date": (String(data.consent6)==="")?"0001-01-01":(cus_data.consent6==data.consent6)?data.consent6_date:newdate,
                    //  "country": "",
                    //  "city": "",
                      "country": data.country,
                      "city": data.city,
                      "date_of_birth": data.date_of_birth,
                      "email_address": data.email_address,
                      "first_name": data.first_name,
                      "id_card_no": data.id_card_no,
                      "last_name": data.last_name,
                      "line_user_id":  data.line_user_id,
                      "mobile_phone_no": data.mobile_phone_no,
                      "post_code": data.post_code,
                      "scheme": data.scheme,
                      "sex": data.sex,
                      "ramianing_point":data.ramianing_point,
                      "confirmdata":true,
                    };
                    // save FireBase
                    const idfirebase=data.club_code+"_"+data.line_user_id;
                    const userDoc = doc(db, "Member",idfirebase);
                       const newFields =  datatotfirebase;
                        updateDoc(userDoc,newFields );
                        setIsOpenLoading(false);
                        console.log("ccc isOpenLoading",isOpenLoading);
                        sessionStorage.setItem("Customerdata", JSON.stringify(data));
                        popupSaveBc()
                        setTimeout(() => {
                        navigate('/homepage')
                        }, 1000);

                          // save FireBase
                  /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                    const resp =  axios.post(urlcreate,datatotfirebase,{
                          headers: {
                      "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                      }
                      })
                      .then(resp=>{
                      console.log(resp);
                      if(resp.data.errors == false){
                        sessionStorage.removeItem('Customerdata');
                        var checkmemberfire =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Get_Web_Member_Data+"?read=insight&userID="+data.line_user_id+"&club_code="+checkcluburl(data.club_code);
                        fetch(checkmemberfire, {
                          headers: {
                          "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                          }
                          })
                          .then(results => results.json())
                          .then(res=>{
                            console.log("Customerdata",res.response.data_member);
                            sessionStorage.setItem("Customerdata", JSON.stringify(res.response.data_member));

                            setIsOpenLoading(false);
                            console.log("ccc isOpenLoading",isOpenLoading);

                            popupSaveBc()
                            setTimeout(() => {
                            navigate('/homepage')
                            }, 1000);

                          })
                          .catch(err=> console.log(err))

                      }else{
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'ไม่สามารถอัพเดตข้อมูลได้ โปรดตรวจสอบ',
                        })
                      }


                    })

                      .catch(err=> console.log(err))*/
                  //delete member
                  }

                })
                .catch(error => {
                   setIsOpenLoading(false);
                  popupNotconnectBc()

                  console.log('editeMember error', error)});

               //--------------------------------------------------------------------->
          // console.log(data);

            // send save data firebase

        };

        async function consentdata() {
          const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
          let setupdefault= ""+setupwebdefault;
            const setupdefaultweb = JSON.parse(setupdefault);
          console.log(setupdefaultweb.consent1_path);
          const storageRefdataconsent = ref_storage(storage, setupdefaultweb.consent1_path);
          getDownloadURL(storageRefdataconsent).then((urldataconsent) => {
            const resdataconsent = axios.get(urldataconsent)
              .then((resdatadataconsent:any)=> {
              //  console.log(resdatadataconsent.data);
                setdataconsent(resdatadataconsent.data)
              })
              .catch(err=> console.log(err))
          });


        }

        async function checkconsentdata() {
          const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
          let setupdefault= ""+setupwebdefault;
            const setupdefaultweb = JSON.parse(setupdefault);
            let arr_consent:any = {};
            // arr_consent['consent2'] = setupdefaultweb.consent2_require;
            // arr_consent['consent3'] = setupdefaultweb.consent3_require;
            // arr_consent['consent4'] = setupdefaultweb.consent4_require;
            // arr_consent['consent5'] = setupdefaultweb.consent5_require;
            // arr_consent['consent6'] = setupdefaultweb.consent6_require;
            // console.log('555',typeof totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent1_path != '' ? totalConsentRequired => totalConsentRequired + 1 : totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent2_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent3_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent4_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent5_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
            // setTotalConsentRequired(setupdefaultweb.consent6_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);

            // console.log(totalConsentRequired);

            setCheckConsentRequired2(setupdefaultweb.consent2_require);
            setCheckConsentRequired3(setupdefaultweb.consent3_require);
            setCheckConsentRequired4(setupdefaultweb.consent4_require);
            setCheckConsentRequired5(setupdefaultweb.consent5_require);
            setCheckConsentRequired6(setupdefaultweb.consent6_require);

            // console.log(checkConsent1);

            arr_consent['consent1'] = setupdefaultweb.consent1_path;
            arr_consent['consent2'] = setupdefaultweb.consent2_code;
            arr_consent['consent3'] = setupdefaultweb.consent3_code;
            arr_consent['consent4'] = setupdefaultweb.consent4_code;
            arr_consent['consent5'] = setupdefaultweb.consent5_code;
            arr_consent['consent6'] = setupdefaultweb.consent6_code;
            // console.log('consent', Object.keys(arr_consent).length);
            Object.entries(arr_consent).map(([key, value]) => {
              // console.log(key.split("_"));
              // const key_split = key.split("_");
              if(!value){
                $('#'+key).hide();
                $('#'+key+'_modal').addClass('d-none');
              }else{
                setTotalConsentRequired(totalConsentRequired => totalConsentRequired + 1);
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
              }

            })
            // setTotalConsentRequired(Object.keys(arr_consent).length);
            // console.log('ffff', totalConsentRequired);
            // const customer_consent = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
            // const arr_consent_member:any = {};
            // arr_consent_member['inlineCheckboxConsent1'] = setupdefaultweb.consent1_require;
            // arr_consent_member['inlineCheckboxConsent2'] = setupdefaultweb.consent2_require;
            // arr_consent_member['inlineCheckboxConsent3'] = setupdefaultweb.consent3_require;
            // arr_consent_member['inlineCheckboxConsent4'] = setupdefaultweb.consent4_require;
            // arr_consent_member['inlineCheckboxConsent5'] = setupdefaultweb.consent5_require;
            // arr_consent_member['inlineCheckboxConsent6'] = setupdefaultweb.consent6_require;

            // Object.entries(arr_consent_member).map(([key, value]) => {
            //   // console.log(key);
            //   // const key_split = key.split("_");
            //   if(value === true){
            //     $('#'+key).prop('checked',true);
            //   }
            // })
            // console.log(arr_consent_member);
          // if(setupdefaultweb.consent2_require == false){
          //   $('#consent2').addClass("d-none");
          // }else if(setupdefaultweb.consent3_require == false){
          //   $('#consent3').addClass("d-none");
          // }else if(setupdefaultweb.consent4_require == false){
          //   $('#consent4').addClass("d-none");
          // }else if(setupdefaultweb.consent5_require == false){
          //   $('#consent5').addClass("d-none");
          // }else if(setupdefaultweb.consent6_require == false){
          //   $('#consent6').addClass("d-none");
          // }


      }

        const clickConsent1 =( e : any) => {
          setShow(false);
          setShowModalConsentOther(true);
        }

        async function consentdataOther() {
          const storageRefdataconsent = ref_storage(storage, 'config_file/consent_web.json');
          const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
          getDownloadURL(storageRefdataconsent).then((urldataconsent) => {
            const resdataconsent = axios.get(urldataconsent)
              .then((resdatadataconsent:any)=> {
                const consentOther:any = [];
                Object.values(resdatadataconsent.data).map((val:any) => {

                  // consentOther.push(val);
                //   console.log(val.consent_code);
                /*  if(val.consent_code == 'CONSENT02'){
                    setContentConsent2(val);
                  }else if(val.consent_code == 'CONSENT03'){
                    setContentConsent3(val);
                  }else if(val.consent_code == 'CONSENT04'){
                    setContentConsent4(val);
                  }else if(val.consent_code == 'CONSENT05'){
                    setContentConsent5(val);
                  }else if(val.consent_code == 'CONSENT06'){
                    setContentConsent6(val);
                  }*/


                  if (setupwebdefaultweb.consent2_code==val.consent_code) {
                    setContentConsent2(val);
                  }
                  if (setupwebdefaultweb.consent3_code==val.consent_code) {
                    setContentConsent3(val);
                  }
                  if (setupwebdefaultweb.consent4_code==val.consent_code) {
                    setContentConsent4(val);
                  }
                  if (setupwebdefaultweb.consent5_code==val.consent_code) {
                    setContentConsent5(val);
                  }
                  if (setupwebdefaultweb.consent6_code==val.consent_code) {
                    setContentConsent6(val);
                  }
                });
                // console.log(consentOther);
                // setdataconsentOther(consentOther)
                // console.log(dataconsentOther);
              })
              .catch(err=> console.log(err))
          });


        }

        // async function setDefaultAddress() {
        //   console.log(5555555);
        //   setSelectedCityDefault([]);

        //   const uniqueIds:any[] = [];

        //     const uniqueCity = city.filter(val => {
        //       // console.log(val.City);
        //       const isDuplicate = uniqueIds.includes(val.City);

        //       if (!isDuplicate) {
        //         // console.log(test2.City);
        //         uniqueIds.push(val.City);

        //         return true;
        //       }

        //       return false;
        //     });

        //   const optionsCity:any = []
        //     uniqueCity.map(value => {
        //       // console.log(test2.County);
        //       if(cus_data.country == value.County) {
        //         optionsCity.push({
        //           label : value.City,
        //           value : value.City
        //         });
        //         // setSelectedCity( selectedCity => [...selectedCity, `${value.City}`]);
        //         // console.log(test2.City);
        //       }
        //     });
        //     setSelectedCityDefault(optionsCity)
        // }

        // console.log(selectedCityDefault);

        // console.log(register("firstName", {
        //   required: true,
        //   maxLength: 20,
        //   pattern: /^[A-Za-z]+$/i
        // }));

        // console.log(data);
        // console.log(selectedCityDefault);
        const [logoImageweb, setLogoImageweb] = useState('');
        const [dobbc, setdobbc] = useState(true);

        async function setfileconfig() {
          const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
          const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
          getDownloadURL(storageRef_logoweb).then((url) => {
            setLogoImageweb(url)
          });
          const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
          const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
          console.log(setupwebdefaultweb.consent1_path);
          if (cus_data.date_of_birth=="0001-01-01") {
            setdobbc(false);
          }else{
            setdobbc(true);
          }
        /*  if (setupwebdefaultweb.consent1_path && setupwebdefaultweb.consent1_require==true) {
            if (cus_data.consent1==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                setIsOpenpopup(true)
                openpopup()
              }

            }
          }
          if (setupwebdefaultweb.consent2_code && setupwebdefaultweb.consent2_require==true) {
            if (cus_data.consent2==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);

                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent3_code && setupwebdefaultweb.consent3_require==true) {
            if (cus_data.consent3==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent4_code && setupwebdefaultweb.consent4_require==true) {
            if (cus_data.consent4==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent5_code && setupwebdefaultweb.consent5_require==true) {
            if (cus_data.consent5==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent6_code && setupwebdefaultweb.consent6_require==true) {
            if (cus_data.consent6==true) {
            }else{
              // popup open
              if (isOpenpopup==false) {
                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }*/






        }
        async function openpopup() {
           //console.log("popuppppp",handleShowConsent1);
           setShow(true);
        }
        //AVCDAPNF.001  23/02/2025  Add Code for Comment เพื่อให้ input checkbox กดจากภายนอกได้
        // $("input:checkbox").on('click', function() {
        //   // console.log('55555');
        //   // in the handler, 'this' refers to the box clicked on
        //   var $box = $(this);
        //   // console.log($box);
        //   if ($box.is(":checked")) {
        //     // the name of the box is retrieved using the .attr() method
        //     // as it is assumed and expected to be immutable
        //     var group = "input:checkbox[name='" + $box.attr("name") + "']";
        //     // the checked state of the group/box on the other hand will change
        //     // and the current value is retrieved using .prop() method
        //     $(group).prop("checked", false);
        //     $box.prop("checked", true);
        //   } else {
        //     $box.prop("checked", false);
        //   }
        // });
        //C-AVCDAPNF.001  23/02/2025  Add Code for Comment เพื่อให้ input checkbox กดจากภายนอกได้
        //AVCDAPNF.001  23/02/2025  Add Code for Comment เพื่อให้ input checkbox กดจากภายนอกได้
        const handlePressCheckbox = (
          event: React.PointerEvent<HTMLInputElement>,
          callback?: React.Dispatch<React.SetStateAction<Boolean | undefined>>
        ) => {
          const name = event.currentTarget.name as keyof IAccount
          const isChecked = !data[name]
          if (name === 'consent1') setCheckConsentBtnClick1((prev) => !prev)
          setData((prev) => ({...prev, [name]: isChecked}))
          if (callback) callback((prev) => !prev)
          setCheckClickConsentRequired((prev) => (isChecked ? prev + 1 : prev - 1))
        }
        //C-AVCDAPNF.001  23/02/2025  Add Code for Comment เพื่อให้ input checkbox กดจากภายนอกได้
        //AVCDAPNF.008  23/02/2025  Add Code for ให้ซ่อนปุ่มยกเลิกสมาชิก
        const [isActive, setIsActive] = useState<boolean>(false)
        //C-AVCDAPNF.008  23/02/2025  Add Code for ให้ซ่อนปุ่มยกเลิกสมาชิก


  	return (


      <div className='card card-homepage'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo' style={styles.background_Style}>
      <img src={logo} alt="metronic"/>
      </div>


        <form className='form d-flex flex-center'  onSubmit={handleSubmit(onSubmit)} >
          <div className='card-body custom-body mw-800px py-20 card-body-editemember' style={styles.foreground_Style}>

            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label editemember-header-label' style={styles.title_style}>ข้อมูลสมาชิก</label>
            </div>
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label block-label' style={styles.title2_style}>ข้อมูลส่วนบุคคล</label>
            </div>

            {/* begin::Form row */}
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>ชื่อ*</label>
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                  {...register("firstName", {
                    required: true,
                    pattern: /^[A-Za-zก-๙]+$/i,
                    maxLength: 30
                  })}
                    className='form-control form-control-lg form-control-solid'
                    type='text'
                    value={data.first_name}
                    // defaultValue={data.first_name}
                    onChange={(e) => updateData({first_name: e.target.value})}
                    // autoComplete="off"
                    style={styles.input_data_style} 
                  />
                  {/* {console.log(errors?.firstName)} */}
                  {errors?.firstName?.type === "required" && <p className="text-danger">กรุณากรอกชื่อ</p>}
                  {/* {console.log(errors?.firstName?.type)} */}
                  {errors?.firstName?.type === "pattern" && (
                    <p className="text-danger">ชื่อต้องเป็นตัวอักษรเท่านั้น</p>
                  )}
                  {errors?.firstName?.type === "maxLength" && (
                    <p className="text-danger">ชื่อต้องไม่เกิน30ตัวอักษร</p>
                  )}
                </div>
              </div>
            </div>
            {/* end::Form row */}
            {/* begin::Form row */}
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>นามสกุล*</label>
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                  {...register("lastName", {
                    required: true,
                    pattern: /^[A-Za-zก-๙]+$/i,
                    maxLength: 30

                  })}
                    className='form-control form-control-lg form-control-solid'
                    type='text'
                    value={data.last_name}
                    onChange={(e) => updateData({last_name: e.target.value})}
                    // autoComplete="off"
                    name="lastName"
                    style={styles.input_data_style}
                  />
                  {errors?.lastName?.type === "required" && <p className="text-danger">กรุณากรอกนามสกุล</p>}
                  {/* {console.log(errors?.firstName?.type)} */}
                  {errors?.lastName?.type === "pattern" && (
                    <p className="text-danger">นามสกุลต้องเป็นตัวอักษรเท่านั้น</p>
                  )}
                  {errors?.lastName?.type === "maxLength" && (
                    <p className="text-danger">นามสกุลต้องไม่เกิน30ตัวอักษร</p>
                  )}
                </div>
              </div>
            </div>
            {/* end::Form row */}
            {/* begin::Form row */}
            <div
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>รหัสบัตรประจำตัวประชาชน*</label>
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                    {...register("idCardNo", {
                      required: true,
                      pattern: /^[0-9]+$/i,
                      minLength: 13,
                      maxLength: 13
                    })}
                    className='form-control form-control-lg form-control-solid'
                    type='number'
                    value={data.id_card_no}
                    onChange={(e) => updateData({id_card_no: e.target.value})}
                    // autoComplete="off"
                    style={styles.input_data_style}
                  />
                  {errors?.idCardNo?.type === "required" && <p className="text-danger">กรุณากรอกรหัสบัตรประชาชน</p>}
                  {errors?.idCardNo?.type === "minLength" && (
                    <p className="text-danger">หมายเลขรหัสบัตรประชาชนต้องมี 13 หลัก</p>
                  )}
                  {errors?.idCardNo?.type === "maxLength" && (
                    <p className="text-danger">หมายเลขรหัสบัตรประชาชนต้องมี 13 หลัก</p>
                  )}
                  {errors?.mobile_phone_number?.type === "pattern" && (
                  <p className="text-danger">หมายเลขรหัสบัตรประชาชนต้องเป็นตัวเลขเท่านั้น</p>
                )}
                </div>
              </div>
            </div>
            {/* end::Form row */}

            {/* begin::Form row */}
            <div
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              {/*avnsd*/}
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>เบอร์โทรศัพท์</label>
              {/*<label className='col-lg-3 col-form-label'>เบอร์โทรศัพท์</label>*/}
              {/*avnsd*/}
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                    {...register("mobile_phone_number", {
                      required: true,
                      pattern: /^[0-9]+$/i,
                      minLength: 10,
                      maxLength: 10
                    })}
                    className='form-control form-control-lg form-control-solid'
                    type='number'
                    value={data.mobile_phone_no}
                    onChange={(e) => updateData({mobile_phone_no: e.target.value})}
                    // autoComplete="off"
                    disabled
                    style={styles.input_data_style}
                  />

                  {errors?.mobile_phone_number?.type === "required" && <p className="text-danger">กรุณากรอกเบอร์โทรศัพท์</p>}
                  {errors?.mobile_phone_number?.type === "minLength" && (
                    <p className="text-danger">หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                  )}
                  {errors?.mobile_phone_number?.type === "maxLength" && (
                    <p className="text-danger">หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                  )}
                  {errors?.mobile_phone_number?.type === "pattern" && (
                    <p className="text-danger">หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น</p>
                  )}
                </div>
              </div>
            </div>
            {/* end::Form row */}

            {/* begin::Form row */}
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              {/*avnsd*/}
              {/*<label className='col-lg-3 col-form-label'  style={styles.caption_style}>อีเมลล์*</label>*/}
              <label className='col-lg-3 col-form-label'  style={styles.caption_style}>อีเมล</label>
              {/*avnsd*/}
              <div className='col-lg-9'>
                <div className='input-group input-group-lg input-group-solid'>

                  <input
                    {...register("email", {
                      //required: true,  //AVNSD
                      pattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    })}
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Email'
                    value={data.email_address}
                    onChange={(e) => updateData({email_address: e.target.value})}
                    // autoComplete="off"
                    style={styles.input_data_style}
                  />


                </div>
                {/*avnsd*/}
                {/*{errors?.email?.type === "required" && <p className="text-danger">ระบุข้อมูลอีเมลไม่ถูกต้อง*</p>}*/}
                {/*avnsd*/}
                  {errors?.email?.type === "pattern" && (
                    <p className="text-danger">ระบุข้อมูลอีเมลไม่ถูกต้อง</p>
                  )}
              </div>
            </div>
            {/* end::Form row */}

            {/* begin::Form row */}
            <div className='row align-items-center mb-3'>
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>เพศ*</label>
              <div className='col-lg-9'>
                <div className='d-flex align-items-center'>
                  <div className='form-check form-check-custom form-check-solid me-5 sex'>
                    <input
                      {...register("sex", {
                        required: true
                      })}
                      className='form-check-input'
                      type='checkbox'
                      id='inlineCheckbox'
                      checked={genderMale == true ? true : false}
                      value="Male"
                      onClick={(e:any) => updateData({sex: e.target.value})}

                    />
                    <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1' style={styles.input_data_style}>
                      ชาย
                    </label>
                  </div>
                  <div className='form-check form-check-custom form-check-solid me-5 sex'>
                    <input
                      {...register("sex", {
                        required: true
                      })}
                      className='form-check-input'
                      type='checkbox'
                      id='inlineCheckbox'
                      checked={genderFemale == true ? true : false}
                      value="Female"
                      onClick={(e:any) => updateData({sex: e.target.value})}
                    />
                    <label className='form-check-label fw-bold' htmlFor='inlineCheckbox2' style={styles.input_data_style}>
                      หญิง
                    </label>
                  </div>
                  <div className='form-check form-check-custom form-check-solid sex'>
                    <input
                      {...register("sex", {
                        required: true
                      })}
                      className='form-check-input'
                      type='checkbox'
                      id='inlineCheckbox'
                      checked={genderNotSpecified == true ? true : false}
                      value="null"
                      onClick={(e:any) => updateData({sex: e.target.value})}
                    />
                    <label className='form-check-label fw-bold' htmlFor='inlineCheckbox3' style={styles.input_data_style}>
                    ไม่ระบุ
                    </label>
                  </div>

                </div>
                {errors?.sex?.type === "required" && <p className="text-danger">กรุณาเลือกเพศ</p>}
              </div>
            </div>
            {/* begin::Form row */}

            {/* begin::Form row */}
            <label className='col-lg-3 col-form-label'  style={styles.caption_style}>วัน/เดือน/ปีเกิด*</label>
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              {/*avnsd*/}
              {/*<div className='col-lg-9'>*/}
              <div className='col-lg-9'>
              {/*avnsd*/}
                <div className='block-bd spinner spinner-sm spinner-primary spinner-right row'>
                {/* <select
                  {...register("checkBirthYear", {
                    required: true
                  })}
                  className='form-select form-select-lg form-select-solid'
                  data-control='select2'

                  data-placeholder='Select postcode...'
                  value={birthyear}
                  // value={(e:any) => console.log(e)}
                  // defaultValue={data.birthyear}
                  onChange={(e) => updateDatabirthyear({year: e.target.value})}
                >
                      <option  value="">
                        เลือกปีเกิด
                      </option>
                  {generateYearOptions()}

                  </select> */}
                  <Controller
                      name="checkBirthYear"
                      control={control}
                      render={({ field: { onChange, value, name, ref }  }) => (
                        <Select
                        // defaultValue={selectedCityDefault.find(e => e.value === cus_data.city,)}
                          // {...register("checkSelectedCity", {
                          //   required: true
                          // })}
                          options={optionsYear}

                          onChange={(e) =>  {
                            onChange(e.value);
                            // e.push({type:'year'});
                            // console.log(val);
                            const val = {
                              label : e.label,
                              value : e.value,
                              type : 'year'
                            }

                            setSelectbirthyear(e.value);
                            // setdataYearofBirth(e);
                            updateDatabirthyear({year: e.value});
                            generateDayOptions(val)

                          }}

                        //  value={optionsYear.find(e => e.value == yearOfBirth )}
                         value={selectBirthYear!=undefined?optionsYear.find(e => e.value === selectBirthYear):optionsYear.find(e => e.value === yearOfBirth)}

                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: '#f6f7ff',
                              border: 'white'
                            }),
                          }}
                          placeholder="เลือกปี"
                          //avnsd
                          //className="col-4"
                          className="col-4"
                          //avnsd
                          
                        />
                      )}
                      rules={{ required: true }}
                    />
                  {/* <select
                    {...register("checkBirthMonth", {
                      required: true
                    })}
                    className='form-select form-select-lg form-select-solid'
                    data-control='select2'
                    data-placeholder='Select postcode...'
                    value={birthmonth}
                    // defaultValue={data.birthmonth}
                    onChange={(e) => updateDatabirthmonth({month: e.target.value})}
                  >
                  <option  >
                    เลือกเดือนเกิด
                  </option>
                {generateMonthOptions()}
                    </select> */}
                  <Controller
                      name="checkBirthMonth"
                      control={control}
                      render={({ field: { onChange, value, name, ref }  }) => (
                        <Select
                        // defaultValue={selectedCityDefault.find(e => e.value === cus_data.city,)}
                          // {...register("checkSelectedCity", {
                          //   required: true
                          // })}
                          options={optionsMonth}
                        //  value={optionsMonth.find(e => e.value === monthOfBirth) }
                          value={dobbc==true?selectBirthMonth!=undefined?optionsMonth.find(e => e.value === selectBirthMonth):optionsMonth.find(e => e.value === monthOfBirth):optionsMonth.find(e => e.value === monthOfBirth)}

                          onChange={(e) => {
                            const val = {
                              label : e.label,
                              value : e.value,
                              type : 'month'
                            }
                            onChange(e.value);
                            // setSelectBirthMonth(e.value);
                            updateDatabirthmonth({month: e.value});
                            generateDayOptions(val);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: '#f6f7ff',
                              border: 'white'
                            }),
                          }}
                          placeholder="เลือกเดือน"
                          //avnsd
                          //className="col-4"
                          className="col-4"
                          //avnsd
                        />
                      )}
                      rules={{ required: true }}
                    />
                    {/* <select
                      {...register("checkBirthDay", {
                        required: true
                      })}
                      className='form-select form-select-lg form-select-solid'
                      data-control='select2'
                      data-placeholder='Select postcode...'
                      value={birthday}
                      // defaultValue={data.birthmonth}
                      onChange={(e) => updateDatabirthday({day: e.target.value})}
                    >
                    <option  >
                      เลือกวันเกิด
                    </option>
                    {generateDayOptions()}
                      </select> */}
                    <Controller
                      name="checkBirthDay"
                      control={control}
                      render={({ field: { onChange, value, name, ref }  }) => (
                        <Select
                        // defaultValue={selectedCityDefault.find(e => e.value === cus_data.city,)}
                          // {...register("checkSelectedCity", {
                          //   required: true
                          // })}
                        {...register("checkBirthDay", {
                          required: true
                        })}
                          options={optionsDay}
                          // onClick={this.generateDayOptions}

                          onChange={(e) => {
                            onChange(e.value);
                            updateDatabirthday({day: e.value});
                          }}
                          value={dobbc==true?selectBirthDay!=undefined?optionsDay.find(e => e.value === selectBirthDay):optionsDay.find(e => e.value === dayOfBirth):optionsDay.find(e => e.value === birthday)}

                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: '#f6f7ff',
                              border: 'white'
                            }),
                          }}
                          placeholder="เลือกวัน"
                          //avnsd
                          //className="col-4"
                          className="col-4"
                          //avnsd
                          // id="test2222"
                        />
                      )}
                      rules={{ required: true }}
                    />
                </div>
                {errors?.checkBirthDay?.type === "required" &&  <p className="text-danger">กรุณาเลือกวันเกิด</p>}
                {errors?.checkBirthMonth?.type === "required" &&  <p className="text-danger">กรุณาเลือกเดือนเกิด</p>}
                {errors?.checkBirthYear?.type === "required" &&  <p className="text-danger">กรุณาเลือกปีเกิด</p>}
                {inputdobbc==true?"":<p className="text-danger">กรุณาเลือกวันเดือนปีเกิด</p>}



              </div>

            </div>
            {/* end::Form row */}

            {/* begin::Form row */}
            {/*avnsd*/}
            {/*<label className='col-lg-3 col-form-label' style={styles.title2_style}>ข้อมูลที่อยู่อาศัย</label>*/}
            <label className='col-lg-3 col-form-label' style={styles.title2_style}>ที่อยู่ที่สามารถติดต่อได้</label>
            {/*avnsd*/}
            <div 
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              {/*avnsd*/}
              {/*<label className='col-lg-3 col-form-label' style={styles.caption_style}>ที่อยู่ 1*</label>*/}
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>บ้านเลขที่ / ชื่อหมู่บ้าน / หมู่ที่*</label>
              {/*avnsd*/}
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                    {...register("checkAddress1", {
                      required: true,
                      maxLength: 100
                    })}
                    className='form-control form-control-lg form-control-solid'
                    type='text'
                    value={data.address}
                    onChange={(e) => updateData({address: e.target.value})}
                    style={styles.input_data_style}
                  />
                  {/*avnsd*/}
                  {/*{errors?.checkAddress1?.type === "required" &&  <p className="text-danger">กรุณากรอกที่อยู่</p>}
                  {errors?.checkAddress1?.type === "maxLength" &&  <p className="text-danger">ที่อยูต้องไม่เกิน100ตัวอักษร</p>}*/}
                  {errors?.checkAddress1?.type === "required" &&  <p className="text-danger">กรุณากรอก บ้านเลขที่ / ชื่อหมู่บ้าน / หมู่ที่</p>}
                  {errors?.checkAddress1?.type === "maxLength" &&  <p className="text-danger">บ้านเลขที่ / ชื่อหมู่บ้าน / หมู่ที่ ต้องไม่เกิน100ตัวอักษร</p>}
                  {/*avnsd*/}
                </div>
              </div>
            </div>
            {/* end::Form row */}

            {/* begin::Form row */}
            <div
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              {/*avnsd*/}
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>ซอย / ถนน / ตำบล/แขวง</label>
              {/*<label className='col-lg-3 col-form-label' style={styles.caption_style}>ที่อยู่ 2*</label>*/}
              {/*avnsd*/}
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input
                  {...register("checkAddress2", {
                    maxLength: 100
                  })}
                    className='form-control form-control-lg form-control-solid'
                    type='text'
                    value={data.address2}
                    onChange={(e) => updateData({address2: e.target.value})}
                    style={styles.input_data_style}
                  />
                  {/*avnsd*/}
                  {/*{errors?.checkAddress2?.type === "maxLength" &&  <p className="text-danger">ที่อยูต้องไม่เกิน100ตัวอักษร</p>}*/}
                  {errors?.checkAddress2?.type === "maxLength" &&  <p className="text-danger">ซอย / ถนน / ตำบล/แขวง ต้องไม่เกิน100ตัวอักษร</p>}
                  {/*avnsd*/}
                </div>
              </div>
            </div>
            {/* end::Form row */}





            {/* begin::Form row */}
            <div
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>จังหวัด*</label>
              <div className='col-lg-9' style={styles.input_data_style}>
                {/* <select
                  className='form-select form-select-lg form-select-solid'
                  data-placeholder='Select City...'
                  data-control='select2'
                  value={data.country}
                  defaultValue={data.country}
                  onChange={(e) => updateDataRegion({country: e.target.value})}
              //  onChange={selectChange}
                >
                {regiononbc()}

                {       Object.entries(region).map((value: any[]) => {
                            return(
                              <option  value={value[1].name}>
                                {value[1].name}
                              </option>

                            )
                       }) }
                  </select> */}
                  <Controller
                    name="checkSelectedRegion"
                    control={control}
                    render={({ field: { onChange, value, name, ref }  }) => (
                      <Select
                        // value={region.filter(function(val) {
                        //   // console.log(val.name);
                        //   // console.log(data.country);
                        //   if(val.name === data.country){
                        //     // console.log(val.name);
                        //     // console.log(data.country);
                        //     return ({ value: val.name, label: val.name })

                        //   }
                        //   // return val.name === JSON.parse(data.country);
                        // })}
                        // defaultValue={region.find(e => e.value === data.country)}
                        // {...register("checkSelectedRegion", {
                        //   required: true
                        // })}
                        // {...field}
                        // {...ref}
                        // {...value}
                        options={region}
                        value={region.find(e => e.value === data.country)}

                        onChange={ (e) => {
                          changeProvince(e);
                          onChange(e.value);
                          setErrorsRegion('');
                          setCheckerrorsRegion(true);
                          resetField("checkSelectedCity2");
                          resetField("checkSelectedPostCode2");
                        //  resetField("checkSelectedPostCode");
                        //  setCheckerrorsCity(false);
                        }}
                        // onChange={(e) => changeProvince(e)}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: '#f6f7ff',
                            border: 'white'
                          }),
                        }}
                        placeholder="เลือกจังหวัด"

                      />
                    )}
                    rules={{ required: true }}
                  />
                  {errors.checkSelectedRegion?.type === "required" && <p className="text-danger">กรุณาเลือกจังหวัด</p>}
                  {errorsRegion != "" ? <p className="text-danger">{errorsRegion}</p> : ''}
                  {/* {console.log(errors?.checkSelectedRegion)} */}

                </div>
              </div>
              {/* end::Form row */}

            {/* begin::Form row */}
            <div
            //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            // className='row mb-8'
            className='row mb-2'
            //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
            >
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>อำเภอ / เขต*</label>
              <div className='col-lg-9' style={styles.input_data_style}>
                {/* <select
                  className='form-select form-select-lg form-select-solid'
                  data-control='select2'
                  data-placeholder='Select City...'
                  value={data.city}
                  defaultValue={data.city}
                  onChange={(e) => updateDataCity({city: e.target.value})}
                >
                <option  >
                  Select City...
                </option>
                {
                  Object.entries(selectedCity).map((value: any[]) => {

                    if (selectedOption==value[1].County) {
                              return(
                                <option  value={value[1].City}>
                                  {value[1].City}
                                </option>

                              )
                            }
                         })

               }
                  </select> */}

                  {checkSelectedCountry === false ?
                    <Controller
                      name="checkSelectedCity"
                      control={control}
                      render={({ field: { onChange, value, name, ref }  }) => (
                        <Select
                        // defaultValue={selectedCityDefault.find(e => e.value === cus_data.city,)}
                          // {...register("checkSelectedCity", {
                          //   required: true
                          // })}
                          options={selectedCityDefault}
                          value={selectedCityDefault.find(e => e.value === data.city )}
                          onChange={(e) => {
                            onChange(e.value);
                            changeCity(e);
                            setErrorsCity('');
                            setCheckerrorsCity(true);
                          //  setCheckerrorsPostCode(false);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: '#f6f7ff',
                              border: 'white'
                            }),
                          }}
                          placeholder="เลือก อำเภอ/เขต"
                        />
                      )}
                      rules={{ required: true }}
                    />
                    :
                    <Controller
                      name="checkSelectedCity2"
                      control={control}
                      render={({ field: { onChange, value, name, ref }  }) => (
                        <Select
                        // defaultValue={selectedCity.find(e => e.value === cus_data.city,)}
                          // {...register("checkSelectedCity", {
                          //   required: true
                          // })}
                          options={selectedCity}
                           value={selectedCity.find(e => e.value === data.city)}
                          onChange={(e) => {
                            onChange(e.value);
                            changeCity(e);
                            setErrorsCity('');
                            setCheckerrorsCity(true);
                            resetField("checkSelectedPostCode2");
                          //  setCheckerrorsPostCode(false);
                          }}

                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: '#f6f7ff',
                              border: 'white'
                            }),
                          }}
                          placeholder="เลือก อำเภอ/เขต"
                        />
                      )}
                      rules={{ required: true }}
                    />
                  }
                   {errors?.checkSelectedCity?.type === "required" && <p className="text-danger">กรุณาเลือกเขต</p>}
                   {errors?.checkSelectedCity2?.type === "required" && <p className="text-danger">กรุณาเลือกเขต</p>}
                   {/*checkerrorsCity ===false ? <p className="text-danger">{errorsCitylabel}</p> : ''*/}
                   {errorsCity != "" ? <p className="text-danger">{errorsCity}</p> : ''}
                   {/* {console.log(errors?.checkSelectedCity)} */}
                </div>
              </div>
              {/* end::Form row */}

              {/* begin::Form row */}
              <div
              //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
              // className='row mb-8'
              className='row mb-2'
              //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
              >
                <label className='col-lg-3 col-form-label' style={styles.caption_style}>รหัสไปรษณีย์*</label>
                <div className='col-lg-9' style={styles.input_data_style}>
                  <div className='spinner spinner-sm spinner-primary spinner-right'>

                    {/* <select
                      className='form-select form-select-lg form-select-solid'
                      data-control='select2'
                      data-placeholder='Select postcode...'
                      value={data.post_code}
                      defaultValue={data.post_code}
                      onChange={(e) => updateData({post_code: e.target.value})}
                    >
                    <option  >
                      Select postcode...
                    </option>
                    {
                      Object.entries(city).map((value: any[]) => {
                        if (selectedOptionCity==value[1].City) {
                                  return(
                                    <option  value={value[1].PostCode}>
                                      {value[1].PostCode}
                                    </option>

                                  )
                                }
                             })
                   }
                      </select> */}
                      {/* {console.log(selectedPostCode.length)} */}
                      {checkSelectedCountry === false ?


                          <Controller
                          name="checkSelectedPostCode"
                          control={control}
                          render={({ field: { onChange, value, name, ref }  }) => (
                            <Select
                            // defaultValue={e => e.value === data.post_code,}
                              // {...register("checkSelectedPostCode", {
                              //   required: true
                              // })}
                              options={selectedPostCodeDefault}
                              value={selectedPostCodeDefault.find(e => e.value === data.post_code)}
                              // onChange={(e) => changePostCode(e)}
                              onChange={(e) => {
                                onChange(e.value);
                                changePostCode(e);
                                setErrorsPostCode('');
                                setCheckerrorsPostCode(true)

                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: '#f6f7ff',
                                  border: 'white'
                                }),
                              }}
                              placeholder="เลือกรหัสไปรณีย์"
                            />
                          )}
                          rules={{ required: true }}
                        />
                        :
                        <Controller
                          name="checkSelectedPostCode2"
                          control={control}
                          render={({ field: { onChange, value, name, ref }  }) => (
                            <Select
                            // defaultValue={{value:cus_data.post_code, label:cus_data.post_code}}
                              // {...register("checkSelectedPostCode", {
                              //   required: true
                              // })}
                              options={selectedPostCode}
                              value={selectedPostCode.find(e => e.value === data.post_code,)}
                              // onChange={(e) => changePostCode(e)}
                              onChange={(e) => {
                                onChange(e.value);
                                changePostCode(e);
                                setErrorsPostCode('');
                                setCheckerrorsPostCode(true)
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: '#f6f7ff',
                                  border: 'white'
                                }),
                              }}
                              placeholder="เลือกรหัสไปรณีย์"
                            />
                          )}
                          rules={{ required: true }}
                        />
                      }
                       {errors?.checkSelectedPostCode?.type === "required" && <p className="text-danger">กรุณาเลือกรหัสไปรษณีย์</p>}
                       {errors?.checkSelectedPostCode2?.type === "required" && <p className="text-danger">กรุณาเลือกรหัสไปรษณีย์</p>}
                       {/*checkerrorsPostCode ===false ? <p className="text-danger">{errorsPostCodelabel}</p> : ''*/}
                       {errorsPostCode != "" ? <p className="text-danger">{errorsPostCode}</p> : ''}
                       {inputpostcodebc==true?"":<p className="text-danger">กรุณาเลือกรหัสไปรษณีย์</p>}

                  </div>
                </div>
              </div>
              {/* end::Form row */}


              <div
              //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
              // className='row mb-8'
              className='row mb-2'
              //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
              >
              <label className='card-label fw-bolder fs-3 mb-1 col-form-label editemember-header-label' style={styles.title_style}>ข้อกำหนดและเงื่อนไขการเก็บข้อมูลส่วนบุคคล</label>
              </div>
                {/* begin::Form row */}
                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent1 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 1 จากภายนอกได้
                        // id='inlineCheckboxConsent1'
                        // onChange={() => updateData({consent1: !data.consent1})}
                        name='consent1'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent1)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 1 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >

                        <span>ยอมรับ</span>

                        <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">นโยบายความเป็นส่วนตัว</button>
                      </label>
                      {isOpen && <Popup
                        content={<>
                          <b>Consent 1</b>
                          <p>
                          นโยบายความเป็นส่วนตัว
                          </p>

                          <div className="modal-footer">
           <button  className="action secondary action-conform-popup"  type="button" ><span>ยอมรับ</span></button>
           <button className="action secondary action-close" type="button" ><span>ยกเลิก</span></button>
         </div>
                        </>}
                        handleClose={togglePopup}
                      />}
                    </div>
                    </div>
                  </div>
                </div>
                {/* begin::Form row */}

                {/* begin::Form row */}

                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent2 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 2 จากภายนอกได้
                        // id='inlineCheckboxConsent2'
                        // onChange={() => updateData({consent2: !data.consent2})}
                        name='consent2'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent2)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 2 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >
                      <span>ยอมรับ</span>

                      <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent2.consent_title}</button>
                      </label>
                    </div>
                    </div>
                  </div>
                </div>
                {/* begin::Form row */}

                {/* begin::Form row */}
                  {objsetweb1.consent3_code?
                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent3 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 3 จากภายนอกได้
                        // id='inlineCheckboxConsent3'
                        // onChange={() => updateData({consent3: !data.consent3})}
                        name='consent3'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent3)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 3 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >
                      <span>ยอมรับ</span>

                      <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent3.consent_title}</button>
                      </label>
                    </div>
                    </div>
                  </div>
                </div>
                : <div></div>
                  }
                {/* begin::Form row */}


                {/* begin::Form row */}
                {objsetweb1.consent4_code?
                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent4 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 4 จากภายนอกได้
                        // id='inlineCheckboxConsent4'
                        // onChange={() => updateData({consent4: !data.consent4})}
                        name='consent4'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent4)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 4 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >
                      <span>ยอมรับ</span>

                      <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent4.consent_title}</button>

                      </label>
                    </div>
                    </div>
                  </div>
                </div> : <div></div>
                  }
                {/* begin::Form row */}
                {/* begin::Form row */}
                {objsetweb1.consent5_code ?
                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent5 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 5 จากภายนอกได้
                        // id='inlineCheckboxConsent5'
                        // onChange={() => updateData({consent5: !data.consent5})}
                        name='consent5'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent5)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 5 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >
                      <span>ยอมรับ</span>

                      <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent5.consent_title}</button>
                      </label>
                    </div>
                    </div>
                  </div>
                </div>: <div></div>
                  }
                {/* begin::Form row */}
                {/* begin::Form row */}
                  {objsetweb1.consent6_code ?
                <div className='row align-items-center mb-3'>
                  <div className='col-lg-9'>
                    <div className='d-flex align-items-center'>
                    <div className='form-check form-check-custom form-check-solid me-5'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={data.consent6 == true ? true : false}
                        //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 6 จากภายนอกได้
                        // id='inlineCheckboxConsent3'
                        // onChange={() => updateData({consent6: !data.consent6})}
                        name='consent6'
                        onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent6)}
                        onChange={() => {}}
                        //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถกด checkbox consent 6 จากภายนอกได้
                      />
                      <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                      //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      style={styles.input_data_style}
                      //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                      >
                      <span>ยอมรับ</span>

                      <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent6.consent_title}</button>
                      </label>
                    </div>
                    </div>
                  </div>
                </div>
                : <div></div>
                  }
                {/* begin::Form row */}


            {/* begin::Form row */}
            <div className='row'>
              <label className='col-lg-3 col-form-label'></label>
              <div className='col-lg-9'>
                {/*avnsd*/}
                {/*<button type='submit'  className='btnmember editemember btn btn-primary fw-bolder px-6 py-3 me-3' >*/}
                <button type='submit'  className='btnmember editemember btn btn-primary fw-bolder px-6 py-3 me-3' style={styles.confirm_button_style}>
                {/*avnsd*/}
                  บันทึก
                </button>
                {/* //AVCDAPNF.008  23/02/2025  Add Code for เพื่อ show และ hide ปุ่มยกเลิกการเป็นสมาชิก */}
                {/* <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <p className='fw-bolder fs-3' style={styles.title_style}>
                    ต้องการยกเลิกการเป็นสมาชิก ?
                  </p>
                  <p
                    className=''
                    onClick={() => setActive(!active)}
                    style={{...styles.title_style, cursor: 'pointer'}}
                  >
                    {active ? '-' : '+'}
                  </p>
                </div>

                <div
                  style={{
                    overflow: 'hidden',
                    maxHeight: active ? '200px' : '0',
                    transition: 'max-height 0.5s linear',
                  }}
                >
                  {active && (
                    <button
                      type='reset'
                      onClick={(e) => handleClickCancelMember()}
                      style={styles.member_cancel_button_style}
                      className='btnmember cancelmember btn btn-color-gray-600 btn-active-light-primary fw-bolder px-6 py-3'
                    >
                      ยกเลิกการเป็นสมาชิก
                    </button>
                  )}
                </div> */}
                <Row gutter={16} justify="center" style={styles.caption_style}>
                  <Col xs={20} md={14}>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                        onClick={() => setIsActive(!isActive)}
                      >
                        <div className="col-lg-3 col-form-label" style={styles.caption_style}>เปลี่ยนเบอร์โทรศัพท์หรือยกเลิกสมาชิก ?</div>
                        <div
                          style={{
                            display: "flex"
                          }}
                        >
                          {isActive ? (
                            <svg xmlns="http://www.w3.org/2000/svg" style={{ width: 20, height: 20 }} viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clipRule="evenodd" />
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" style={{ width: 20, height: 20 }} viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                            </svg>
                          )}
                        </div>
                      </div>
                      {isActive && (

                        
                        <React.Fragment>
                          <div className='col-lg-9'>
                            <label className='col-lg-3 col-form-label'></label>
                            <button
                              type='reset'  onClick={(e) => navigate("/change-mobile-phone") }
                              className='btnmember cancelmember btn btn-active-light-primary fw-bolder px-6 py-3'
                              style={styles.general_button_style}
                            >
                            เปลี่ยนเบอร์โทรศัพท์
                            </button>
                          </div>
                          <div className='col-lg-9'>
                            <label className='col-lg-3 col-form-label'></label>
                            <button
                              type='reset'  onClick={(e) => handleClickCancelMember() }  style={styles.cancel_button_style}
                              className='btnmember cancelmember btn btn-color-gray-600 btn-active-light-primary fw-bolder px-6 py-3'
                            >
                            ยกเลิกการเป็นสมาชิก
                            </button>
                          </div>
                        </React.Fragment>

                      )}
                    </div>
                  </Col>
                </Row>
                {/* //C-AVCDAPNF.008  23/02/2025  Add Code for เพื่อ show และ hide ปุ่มยกเลิกการเป็นสมาชิก */}
              </div>
            </div>
            {/* end::Form row */}
          </div>
        </form>
        {/* end::Form */}
        <Modal
        onEntered=  { function(){
            // console.log(cus_data.consent1);
            if(
              cus_data.consent1 === true && 
              //AVCDAPNF.001  23/02/2025  Add Code for ปุ่มกด consent 1 disable ตามข้อมูล customer data
              data.consent1 === true
              //C-AVCDAPNF.001  23/02/2025  Add Code for ปุ่มกด consent 1 disable ตามข้อมูล customer data
            ){
              setCheckChangeConsent1(true);
              setCheckConsentBtnClick1(true);
            //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
            }
          }
        }
        scrollable={true} show={show} onHide={handleCloseConsent1} id="consent1" >
            <Modal.Header closeButton className="bg-secondary1"  style={styles.consent_page_style_header}>
            <Modal.Title><h2 style={styles.title_consent_style}>นโยบายความเป็นส่วนตัว</h2></Modal.Title>
              {/* <Modal.Title><h2>CONSENT 1</h2></Modal.Title> */}
            </Modal.Header>

            <Modal.Body className="bg-secondary1" style={styles.consent_page_style_body}>
              <div style={styles.description_consent_style} dangerouslySetInnerHTML={{ __html: dataconsent }} />
              <div  className="agree_box" style={styles.agree_box_consent}>
              <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 ">
                    <Form.Check inline id="check_consent1" defaultChecked={data.consent1 == true ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if(e.currentTarget.checked == true){
                              setCheckChangeConsent1(true);
                              updateData({consent1: true})
                          //  setCheckConsentBtnClick1(true);
                          //avnsd
                          setCheckConsentBtnClick1(true);
                              //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          //avnsd  
                          //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          setCheckClickConsentRequired((prev) => prev + 1)
                          //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            }else{
                              setCheckChangeConsent1(undefined);
                          //  setCheckConsentBtnClick1(false);
                              updateData({consent1: false})
                              //avnsd
                              setCheckConsentBtnClick1(false);
                              //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                              //avnsd
                              //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                              setCheckClickConsentRequired((prev) => prev - 1)
                              //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            }

                        }}
                      />
                      <span className="agree_box_consent" >
                        ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>นโยบายความเป็นส่วนตัว</strong>
                    </span>
              </Container>
              </div>
            </Modal.Body>

            <Modal.Footer className="flex-column bg-secondary1" style={styles.consent_page_style_footer}>
            {/* <InputGroup className="mb-5 border-0">
              <InputGroup.Checkbox aria-label="Checkbox for following text input" className="border-0 bg-secondary1"/>
              <Form.Control aria-label="Text input with checkbox" value="55555" className="border-left-0"/>
            </InputGroup> */}

              {/*avnsd*/}
              {/*<Button variant="primary" id="btn_confirm_consent1" onClick={(e) => clickConsent1(e)} className="w-100 btn btn-success" disabled={checkConsentBtnClick1 === true ? false : true}>*/}
              <Button variant="primary" id="btn_confirm_consent1" onClick={(e) => clickConsent1(e)} className="w-100 btn btn-success" disabled={checkConsentBtnClick1 === true ? false : true} style={styles.confirm_button_style}>
              {/*avnsd*/}
                ตกลง
              </Button>
            </Modal.Footer>
          </Modal>
          {/* onEntered= { function(){
            const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
            let setupdefault= ""+setupwebdefault;
              const setupdefaultweb = JSON.parse(setupdefault);
              let arr_consent:any = {};
              arr_consent['consent2'] = setupdefaultweb.consent2_require;
              arr_consent['consent3'] = setupdefaultweb.consent3_require;
              arr_consent['consent4'] = setupdefaultweb.consent4_require;
              arr_consent['consent5'] = setupdefaultweb.consent5_require;
              arr_consent['consent6'] = setupdefaultweb.consent6_require;
              Object.entries(arr_consent).map(([key, value]) => {
                // console.log(key.split("_"));
                // const key_split = key.split("_");
                if(value == false){
                  $('#'+key).hide();
                  $('#'+key+'_modal').addClass('d-none');
                }
              })
            }
          } */}
          <Modal
          onEntered=  { function(){
                          const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
                          let setupdefault= ""+setupwebdefault;
                          const setupdefaultweb = JSON.parse(setupdefault);
                          let arr_consent:any = {};
                          let check_cus_consent:any = {};
                          arr_consent['consent2'] = setupdefaultweb.consent2_code;
                          arr_consent['consent3'] = setupdefaultweb.consent3_code;
                          arr_consent['consent4'] = setupdefaultweb.consent4_code;
                          arr_consent['consent5'] = setupdefaultweb.consent5_code;
                          arr_consent['consent6'] = setupdefaultweb.consent6_code;

                          check_cus_consent['consent2'] = cus_data.consent2;
                          check_cus_consent['consent3'] = cus_data.consent3;
                          check_cus_consent['consent4'] = cus_data.consent4;
                          check_cus_consent['consent5'] = cus_data.consent5;
                          check_cus_consent['consent6'] = cus_data.consent6;
                          const number = 2;
                          //setCheckClickConsentRequired(0);
                          Object.entries(arr_consent).map(([key, value]) => {
                            // console.log(key.split("_"));
                            // const key_split = key.split("_");
                            if(!value){
                              // $('#'+key).hide();
                              $('#'+key+'_modal').hide();
                            }else{
                              Object.entries(check_cus_consent).map(([key_cus, value_cus]) => {
                                // console.log(key_cus, key, value_cus);
                                if(key == key_cus){
                                  if(value_cus != undefined){
                                  //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                                    if(value_cus == true){

                                      // const test = 'setCheckChangeConsent2';
                                      // test(false);
                                      // setCheckChangeConsent+number(false);
                                      // $('#check_'+key_cus+'_approve').attr("disabled","disabled");
                                      const el:any = document.getElementById('check_'+key_cus+'_Non_approve');
                                    //  el.disabled = true;
                                      // console.log(el);
                                      // el.disabled=true;
                                      // console.log(el);
                                      // if(value_cus == true){
                                      //   setCheckChange+key_cus(true);
                                      // }else if(value_cus == false){
                                      //   setCheckChange+key_cus(false);
                                      // }
                                    }else if(value_cus == false){
                                      const el:any = document.getElementById('check_'+key_cus+'_approve');
                                    //  el.disabled = true;
                                    }
                                  }
                                }
                              })
                            }
                          })
                          console.log(totalConsentRequired);
                        }
                      }
          scrollable={true} show={showModalConsentOther} onHide={handleCloseConsentOther} id="consentOther">
            <Modal.Header closeButton className="bg-secondary1" style={styles.consent_page_style_header}>
              {/* <Modal.Title><h2>CONSENT 2</h2></Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="bg-secondary1" style={styles.consent_page_style_body}>
            {/*avnsd*/}
            <h2 style={styles.title_consent_style}>ข้าพเจ้ายินยอมและอนุญาตให้ บริษัท พี แอนด์ เอฟ อินทิเกรท จำกัด ("บริษัทฯ") ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลทำการเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าภายใต้เงื่อนไขดังต่อไปนี้</h2>
            <br></br>
            {/*avnsd*/}
              <Col id="consent2_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent2.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 "  style={ checkConsentRequired2 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other" type="checkbox" defaultChecked={data.consent2 == true ? true : false}
                        onClick={(e) => {
                          if(e.currentTarget.checked == true){
                              updateData({consent2: true})
                            setCheckChangeConsent2(true);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev + 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }else{
                              updateData({consent2: false})
                            setCheckChangeConsent2(undefined);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev - 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent2.consent_title}</strong>
                    </span>

                </Container>
                </div>
              <div  className="agree_box" style={styles.agree_box_consent}>
             <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 " style={ checkConsentRequired2 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent2_approve" name="group2" type="radio"
                  //   disabled={(checkChangeConsent2 == false && checkChangeConsent2 != undefined) ? true : false}
                     defaultChecked={data.consent2 == true || checkChangeConsent2 == true? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent2==false) {
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                          }else if(checkChangeConsent2==true){
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                          }else{
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }
                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent2.consent_title}</strong>
                    </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent2_Non_approve" name="group2" type="radio"
                    //  disabled={checkChangeConsent2 == true ? true : false}
                     defaultChecked={data.consent2 == false ||  checkChangeConsent2 == false ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent2==true) {
                            updateData({consent2: false})
                            setCheckChangeConsent2(false);
                          }else if(checkChangeConsent2==false){
                            updateData({consent2: false})
                            setCheckChangeConsent2(false);
                          }else{
                            updateData({consent2: false})
                            setCheckChangeConsent2(false);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                </div>
              </Col>
              <Col id="consent3_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent3.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 "  style={ checkConsentRequired3 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"  type="checkbox" defaultChecked={data.consent3 == true ? true : false}
                        onClick={(e) => {
                          if(e.currentTarget.checked == true){
                              updateData({consent3: true})
                            setCheckChangeConsent3(true);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev + 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }else{
                              updateData({consent3: undefined})
                            setCheckChangeConsent3(undefined);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev - 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }
                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent3.consent_title}</strong>
                    </span>

                </Container>
                </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 " style={ checkConsentRequired3 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent3_approve" name="group3" type="radio"
                      // disabled={checkChangeConsent3 == false ? true : false}
                      defaultChecked={data.consent3 == true || checkChangeConsent3 == true? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent3==false) {
                            updateData({consent3: true})
                            setCheckChangeConsent3(true);
                          }else if(checkChangeConsent3==true){
                            updateData({consent3: true})
                            setCheckChangeConsent3(true);
                          }else{
                            updateData({consent3: true})
                            setCheckChangeConsent3(true);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent3.consent_title}</strong>
                    </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent3_Non_approve" name="group3" type="radio"
                      // disabled={checkChangeConsent3 == true ? true : false}
                      defaultChecked={data.consent3 == false ||  checkChangeConsent3 == false ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent3==true) {
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                          }else if(checkChangeConsent3==false){
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                          }else{
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                </div>
              </Col>
              <Col id="consent4_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent4.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 "  style={ checkConsentRequired4 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other" type="checkbox" defaultChecked={data.consent4 == true ? true : false}
                        onClick={(e) => {
                          if(e.currentTarget.checked == true){
                              updateData({consent4: true})
                            setCheckChangeConsent4(true);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev + 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }else{
                              updateData({consent4: false})
                            setCheckChangeConsent4(undefined);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev - 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent4.consent_title}</strong>
                    </span>

                </Container>
                </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 " style={ checkConsentRequired4 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent4_approve" name="group4" type="radio"
                      // disabled={checkChangeConsent4 == false ? true : false}
                      defaultChecked={data.consent4 == true || checkChangeConsent4 == true? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent4==false) {
                            updateData({consent4: true})
                            setCheckChangeConsent4(true);
                          }else if(checkChangeConsent4==true){
                            updateData({consent4: true})
                            setCheckChangeConsent4(true);
                          }else{
                            updateData({consent4: true})
                            setCheckChangeConsent4(true);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent4.consent_title}</strong>
                    </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent4_Non_approve" name="group4" type="radio"
                      // disabled={checkChangeConsent4 == true ? true : false}
                      defaultChecked={data.consent4 == false ||  checkChangeConsent4 == false ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent4==true) {
                            updateData({consent4: false})
                            setCheckChangeConsent4(false);
                          }else if(checkChangeConsent4==false){
                            updateData({consent4: false})
                            setCheckChangeConsent4(false);
                          }else{
                            updateData({consent4: false})
                            setCheckChangeConsent4(false);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                </div>
              </Col>
              <Col id="consent5_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent5.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 "  style={ checkConsentRequired5 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"  type="checkbox" defaultChecked={data.consent5 == true ? true : false}
                        onClick={(e) => {
                          if(e.currentTarget.checked == true){
                              updateData({consent5: true})
                            setCheckChangeConsent5(true);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev + 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }else{
                              updateData({consent5: false})
                            setCheckChangeConsent5(undefined);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev - 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent5.consent_title}</strong>
                    </span>

                </Container>
                </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 " style={ checkConsentRequired5 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent5_approve" name="group5" type="radio"
                      // disabled={checkChangeConsent5 == false ? true : false}
                      defaultChecked={data.consent5 == true || checkChangeConsent5 == true? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent5==false) {
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                          }else if(checkChangeConsent5==true){
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                          }else{
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent5.consent_title}</strong>
                    </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent5_Non_approve" name="group5" type="radio"
                      // disabled={checkChangeConsent5 == true ? true : false}
                      defaultChecked={data.consent5 == false ||  checkChangeConsent5 == false ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent5==true) {
                            updateData({consent5: false})
                            setCheckChangeConsent5(false);
                          }else if(checkChangeConsent5==false){
                            updateData({consent5: false})
                            setCheckChangeConsent5(false);
                          }else{
                            updateData({consent5: false})
                            setCheckChangeConsent5(false);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                </div>
              </Col>
              <Col id="consent6_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent6.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 "  style={ checkConsentRequired6 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"  type="checkbox" defaultChecked={data.consent6 == true ? true : false}
                        onClick={(e) => {
                          if(e.currentTarget.checked == true){
                              updateData({consent6: true})
                            setCheckChangeConsent6(true);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev + 1)
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }else{
                              updateData({consent6: false})
                            setCheckChangeConsent6(undefined);
                            //avnsd
                            //setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            //AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                            setCheckClickConsentRequired((prev) => prev - 1);
                            //C-AVCDAPNF.001  23/02/2025  Add Code for ให้สามารถ update required consent ได้
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent6.consent_title}</strong>
                    </span>

                </Container>
                </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5 " style={ checkConsentRequired6 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent6_approve" name="group6" type="radio"
                      // disabled={checkChangeConsent6 == false ? true : false}
                      defaultChecked={data.consent6 == true || checkChangeConsent6 == true? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent6==false) {
                            updateData({consent6: true})
                            setCheckChangeConsent6(true);
                          }else if(checkChangeConsent6==true){
                            updateData({consent6: true})
                            setCheckChangeConsent6(true);
                          }else{
                            updateData({consent6: true})
                            setCheckChangeConsent6(true);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent6.consent_title}</strong>
                    </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent6_Non_approve" name="group6" type="radio"
                    //  disabled={checkChangeConsent6 == true ? true : false}
                      defaultChecked={data.consent6 == false ||  checkChangeConsent6 == false ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent6==true) {
                            updateData({consent6: false})
                            setCheckChangeConsent6(false);
                          }else if(checkChangeConsent6==false){
                            updateData({consent6: false})
                            setCheckChangeConsent6(false);
                          }else{
                            updateData({consent6: false})
                            setCheckChangeConsent6(false);
                          //  setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }

                        }}
                      />
                      <span className="agree_box_consent" >
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                </div>
              </Col>
            {/*avnsd*/}
            <h2 style={styles.title_consent_style}>ข้าพเจ้าได้อ่านข้อความข้างต้นและเข้าใจโดยตลอดแล้ว</h2>
            {/*avnsd*/}          
            </Modal.Body>


            <Modal.Footer className="flex-column bg-secondary1" style={styles.consent_page_style_footer}>
            {/* <InputGroup className="mb-5 border-0">
              <InputGroup.Checkbox aria-label="Checkbox for following text input" className="border-0 bg-secondary"/>
              <Form.Control aria-label="Text input with checkbox" value="55555" className="border-left-0"/>
            </InputGroup> */}

              {/*avnsd*/}
              {/*<Button variant="primary" id="btn_confirm_consent_other"
                onClick={() =>
                  [
                    handleCloseConsentOther(),
                    setCheckBtnConfirmBeforeOtp(true)
                  ]
                }
              className="w-100 btn btn-success" >*/}
              <Button variant="primary" id="btn_confirm_consent_other"
                onClick={() =>
                  [
                    handleCloseConsentOther(),
                    setCheckBtnConfirmBeforeOtp(true)
                  ]
                }
              className="w-100 btn btn-success" style={styles.confirm_button_style}>
              {/*avnsd*/}
                ตกลง
              </Button>
            </Modal.Footer>
          </Modal>
        {isOpen && <Popup
          content={<>
            <b>Consent 1</b>
            <p>
            นโยบายความเป็นส่วนตัว
            </p>
            <div className="modal-footer">
          <button  className="action secondary action-conform-popup"  type="button" ><span>ยอมรับ</span></button>
          <button className="action secondary action-close" type="button" ><span>ยกเลิก</span></button>
          </div>
          </>}
          handleClose={togglePopup}
        />}
        {isOpenCancelmember && <Popup
          content={<>
            <div className="box" style={styles.confirm_message_box_style}>
          {/* <img src={warning} alt="failedlogo" className="img-correct"/> */}
          <p style={styles.title_message_box_style}>ยกเลิกการเป็นสมาชิก</p>
          {/*avnsd*/}
          <p style={styles.description_confirm_message_box_style}>การยกเลิกสมาชิก จะทำให้ระบบลบข้อมูลสมาชิก และคะแนนสะสมทั้งหมดของท่านออกจากระบบ ทั้งนี้จะไม่สามารถกู้คืนข้อมูลและคะแนนได้</p>
          {/*<p style={styles.description_confirm_message_box_style}>การยกเลิกสมาชิก จะมีผลทำให้ระบบลบข้อมูล
ส่วนตัวออกจากระบบ และไม่สามารถกู้คืนได้</p>*/}
          {/*avnsd*/}
          <div className='row confirmdata'>
            <label className='col-lg-3 col-form-label'></label>
            <div className='col-lg-9'>
              <button type='reset' style={styles.cancel_button_style}  onClick={() => togglePopupCancelmember } className='btncancleconfirm editemember btn btn-primary fw-bolder px-6 py-3 me-3'>
                {/*avnsd*/}
                {/*ไม่ถูกต้อง*/}
                ไม่ต้องการยกเลิกสมาชิก
                {/*avnsd*/}
              </button>
              <button type='submit'  style={styles.confirm_button_style} onClick={() => confirmCancelMember() }  className='btnconfirm editemember btn btn-primary fw-bolder px-6 py-3 me-3'>
                {/*avnsd*/}
                ต้องการยกเลิกสมาชิก
                {/*avnsd*/}
              </button>

            </div>
          </div>
      </div>
          </>}

          handleClose={togglePopupCancelmember}
        />}
        {isOpenSaveBc && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
            <img src={successlogo} alt="success" className="img-correct"/>

            <p>ระบบได้ทำการบันทึกข้อมูลเรียบร้อย</p>
            <p>กรุณาตรวจสอบข้อมูล</p>

        </div>
          </>}
          handleClose={togglePopupSaveBc}
        />}
        {isOpenLoading && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
              <h2>Loading....</h2>
              <img src={loadingicon} alt="success" className="img-correct loading-icon"/>


        </div>
          </>}

        />}
        {isOpenCheckconsent && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
            <img src={failedlogo} alt="failedlogo" className="img-correct"/>
            {/*avnsd*/}
            {/*<p>กรุณาใส่ข้อมูล Consent </p>*/}
            <p>กรุณาระบุข้อกำหนดและเงื่อนไขการเก็บข้อมูลส่วนบุคคล</p>
            {/*avnsd*/}

        </div>
          </>}
          handleClose={togglePopupCheckconsent}
        />}
        {isOpenNotconnectBc && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
            <img src={failedlogo} alt="failedlogo" className="img-correct"/>
            <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                กรุณาทำรายการภายหลังอีกครั้ง
                ขออภัยในความไม่สะดวก
                Error Code : 004
                </p>

        </div>
          </>}
          handleClose={togglePopupNotconnectBc}
        />}
      </div>
  	)
}
